export enum ConcessionControlStatus {
    WAITING = 1,
    PROCESSING = 2,
    AVAILABLE = 3,
    AWAITING_THE_ANNUAL_ORDER = 4,
}

export const CC_STATUS_CONSTANTS = [
    {
        label: 'En attente de la commande annuelle',
        value: ConcessionControlStatus.AWAITING_THE_ANNUAL_ORDER,
    },
    {
        label: 'En attente de vos données',
        value: ConcessionControlStatus.WAITING,
    },
    {
        label: 'Traitement en cours',
        value: ConcessionControlStatus.PROCESSING,
    },
    {
        label: 'Disponible',
        value: ConcessionControlStatus.AVAILABLE,
    },
];

export const CC_CONSTANTS = {
    welcome: {
        path: 'welcome',
        icon: 'bi bi-house',
        sidebarLabel: 'Accueil',
        title: 'Accueil',
        subTitle: 'Contrôle de concession',
        texts: {
            default: {
                descriptionTitle: `Extrait de l'article 2 du cahier des charges de concession pour le service public du développement et de l’exploitation du réseau public de distribution d'électricité et de la fourniture d'énergie électrique aux tarifs réglementés de vente :`,
                descriptionContent: ` (...) Les ouvrages concédés comprennent l'ensemble des installations affectées à la distribution publique de l'énergie électrique existant au moment de la signature du présent contrat, dans le périmètre de la concession, ainsi que toutes celles de tension strictement inférieure à 50 000 Volts, qui seront établies par le gestionnaire du réseau de distribution avec l'accord de l'autorité concédante ou par l'autorité concédante avec l'accord du gestionnaire du réseau de distribution.
Ils comprennent également les ouvrages de tension supérieure, existant à la date de publication de la loi n° 2004-803 du 9 août 2004, non exploités par RTE en tant que gestionnaire du réseau public de transport.
Les ouvrages concédés comprennent aussi les branchements visés à l'article 29 du présent cahier des charges, les compteurs, ainsi que leurs accessoires et les concentrateurs de grappes de compteurs.
Conformément aux dispositions de l'article L. 322-4 du code de l' énergie, la partie des postes sources transformant la haute tension en moyenne tension et ses accessoires, intégrés au réseau public de distribution, constituent des ouvrages de ce réseau tels que définis par le présent cahier des charges et sont la propriété du gestionnaire du réseau de distribution. Celui -ci met à la disposition de la
concession, jusqu'au terme du présent contrat, tout ou partie de ceux de ces ouvrages, existants ou à créer, qui contribuent à son alimentation, sous réserve des besoins des autres concessions et des utilisateurs des réseaux publics de distribution.
Les autres ouvrages du réseau public de distribution sont la propriété de l'autorité concédante de la distribution publique d'électricité (...)
`,
            },
            concessionContractSigningDate: {
                title: 'Date de signature du contrat de concession',
            },
            currentConcessionContractDuration: {
                title: 'Durée du contrat de concession en vigueur',
                suffix: ' ans',
                precision: 0,
            },
            concessionHoldersNames: { title: 'Nom des concessionnaires' },
            processedConcessionContractYear: { title: 'Exercice des données' },
            mvUndergroundingRate: {
                title: "Taux d'enfouissement des réseaux HTA",
                suffix: ' %',
                precision: 1,
                badgeSuffix: ' points',
                badgePrecision: 1,
                descriptionContent:
                    "Le taux d'enfouissement HTA correspond à la proportion des réseaux HTA souterrains (y compris en galerie) par rapport aux linéaires totaux HTA",
            },
            lvUndergroundingRate: {
                title: "Taux d'enfouissement des réseaux BT",
                suffix: ' %',
                precision: 1,
                badgeSuffix: ' points',
                badgePrecision: 1,
                descriptionContent:
                    "Le taux d'enfouissement BT correspond à la proportion des réseaux BT souterrains (y compris en galerie) par rapport aux linéaires totaux BT",
            },
            linkyDeploymentRate: {
                title: 'Taux de déploiement des compteurs Linky C5',
                suffix: ' %',
                precision: 0,
                footerPrefix: 'Moyenne AEC: ',
                footerPrecision: 0,
                footerSuffix: ' %',
            },
            criterionBHix: {
                title: 'Critère B HIX (dont RTE)',
                suffix: ' minutes',
                precision: 0,
                footerPrefix: 'Moyenne Enedis: ',
                footerPrecision: 0,
                footerSuffix: ' minutes',
                descriptionTitle: 'Critère B HIX (dont RTE)',
                descriptionContent: `Le Critère B correspond à la durée moyenne annuelle d'interruption de fourniture par usager BT.
Il comprend les interruptions pour incidents sur les réseaux HTA et BT, et pour travaux sur les réseaux HTA et BT. Il comprend également les interruptions sur le réseau de transport RTE et dans les Postes Sources.
La spécifité HIX (Hors Evènements Exceptionnels) précise que les interruptions exceptionnelles sont exclues selon la définition de la CRE dans le TURPE (évènements climatiques de grande ampleur (probabilité d’occurrence annuelle inférieure à 5 % pour la zone géographique considérée dès que, lors d’une même journée et pour la même cause, au moins 100 000 consommateurs finals alimentés par le réseau public de transport et/ou par les réseaux publics de distribution sont privés d’électricité), vols de métaux, malveillance, incendies externes, etc.)`,
            },
            totalInvestments: {
                title: "Investissements annuels totaux d'Enedis (CAPEX)",
                precision: 0,
                suffix: ' M€',
                badgePrecision: 1,
                badgeSuffix: ' %',
            },
            totalNumberOfUsers: {
                title: "Nombre total d'usagers en soutirage (Enedis)",
                descriptionContent: `Le nombre total d'usagers comprend les usagers BT < 36 kVA, BT > 36 kVA et HTA, selon la base clientèle du distributeur.`,
                precision: 0,
                badgePrecision: 1,
                badgeSuffix: ' %',
            },
        },
    },

    generalInfo: {
        path: 'general-info',
        icon: 'bi bi-info-square',
        sidebarLabel: 'Infos générales',
        title: 'Informations générales',
        subTitle: '',
        texts: {
            municipalitiesChart: {
                title: "Evolution annuelle du nombre de communes en concession, et du nombre total d'usagers (base clientèle d'Enedis)",
                descriptionContent:
                    'Le nombre total de communes en concession indiqué, prend notamment en compte les communes déléguées au sein des communes nouvelles. Selon le détail présenté par le distributeur dans ses bases techniques.',
                nbUsersAxisTitle: "Nombre d'usagers",
                nbMunicipalitiesAxisTitle: 'Nombre de communes',
                yaxisTitleLeft: `Nombre de communes`,
                yaxisTitleRight: `Nombre d'usagers`,
                xaxisTitle: `Exercices`,
            },
        },
    },

    sourceStations: {
        path: 'infrastructure/source-stations',
        icon: 'bi bi-lightning-charge',
        sidebarLabel: 'Postes sources',
        title: 'Ouvrages',
        subTitle: 'Postes Sources HTB/HTA',
        texts: {
            nbSourceStationsSupplying: {
                title: 'Nombre total de postes sources alimentant la concession',
                descriptionTitle: 'Précision',
                descriptionContent:
                    "Les postes sources hébergent les transformateurs HTB/HTA, permettant d'assurer la conversion de tension entre le réseau de transport et le réseau de distribution HTA.",
                precision: 0,
                badgePrecision: 0,
            },
            nbSourceStationsIn: {
                title: 'Nombre total de postes sources situés sur la concession',
                precision: 0,
                badgePrecision: 0,
            },
            sourceStationsPowerSupplying: {
                title: 'Puissance totale des postes sources alimentant la concession (en MVA)',
                suffix: ' MVA',
                precision: 0,
                badgePrecision: 0,
                badgeSuffix: ' MVA',
            },
            nbTransformersSupplying: {
                title: 'Nombre total de transformateurs HTB/HTA équipant les postes sources alimentant la concession',
                precision: 0,
                badgePrecision: 0,
            },

            sourceStationsChart: {
                title: "Evolution annuelle du nombre de postes sources sur la concession, ou l'alimentant, et de la puissance totale installée des postes sources (en MVA)",
                nbSourceStationsSupplyingConcessionAxisTitle:
                    'Nombre de postes sources alimentant la concession',
                nbSourceStationsInConcessionAxisTitle:
                    'Dont nombre de postes sources sur la concession',
                nbTransformersSupplyingConcessionAxisTitle:
                    'Puissance totale des postes sources alimentant la concession (en MVA)',
                precision: null,
                yaxisTitleLeft: `Nombre de postes sources`,
                yaxisTitleRight: `Puissance totale (MVA)`,
                xaxisTitle: `Exercices`,
            },

            localizationMap: {
                title: "Carte de localisation des postes sources alimentant la concession, et répartition du nombre d'usagers en soutirage (base technique)  par commune de la concession",
                descriptionTitle: 'Précision',
                descriptionContent:
                    'Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.',
            },
        },
    },

    mvNetworks: {
        path: 'infrastructure/mv-networks',
        sidebarLabel: 'Réseaux HTA',
        title: 'Ouvrages',
        subTitle: 'Réseaux HTA',
        tabs: {
            undergrounding: {
                path: 'undergrounding',
                title: 'Enfouissement HTA',
                texts: {
                    totalMvNetworkLength: {
                        title: 'Longueur totale des réseaux HTA (en km)',
                        descriptionContent:
                            "Les réseaux HTA (aériens ou souterrains) permettent depuis les postes sources d'alimenter les postes HTA/BT ou de raccorder les usagers HTA (en soutirage ou en injection). Leur niveau de tension nomimale est principalement de 20 000 V, mais il peut exister également dans certains secteurs des niveaux de tension HTA inférieurs.",
                        suffix: ' km',
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    mvBurialRate: {
                        title: 'Taux d’enfouissement HTA (en %)',
                        descriptionContent:
                            "Le taux d'enfouissement HTA correspond à la proportion des réseaux HTA souterrains (y compris en galerie) par rapport aux linéaires totaux HTA",
                        suffix: ' %',
                        precision: 1,
                        badgeSuffix: ' Points',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    mvFeedersCount: {
                        title: 'Nombre de départs HTA alimentant la concession',
                        descriptionContent:
                            "Un départ HTA est qualifié 'alimentant à la concession' à la condition qu'il désserve au moins un poste HTA/BT qui est situé sur une commune appartenant à la concession.",
                        suffix: ' km',
                        precision: 0,
                        badgePrecision: 0,
                        descriptionTitle: 'Précision',
                    },
                    mvFeedersOver70kmCount: {
                        title: 'Nombre de départs HTA alimentant la concession de plus de 70 km',
                        precision: 0,
                        footerSuffix: ' km',
                        footerPrecision: 0,
                    },
                    mvUndergroundRateChart: {
                        title: "Positionnement du taux d'enfouissement HTA de la concession, selon la densité d'usagers (usagers/km HTA) et par rapport aux taux des départements métropolitains",
                        descriptionContent:
                            "Quatre départements d'Ile-de-France (75, 92, 93 et 94) sont exclus de ce benchmark. En effet, ces 4 départements avec des taux d'enfouissement HTA de 100% présentent des densités d'usagers comprises entre 200 et 350 usagers/km, qui sont très supérieurs au reste de l'hexagone, ce qui rendraient illisible le nuage de points. Le 5ème département au classement de la densité (et donc le maximum du benchmark) est les Alpes-Maritimes avec 180 usagers/km.",
                        descriptionTitle: 'Précision',
                        mvUndergroundRateConcessionAxisTitle: 'Ma concession',
                        mvUndergroundRateDepartmentAxisTitle: `Autres départements`,
                        precision: 1,
                        xaxisTickAmount: 25,
                        xmin: 0,
                        xmax: 300,
                        tickStep: 25,
                        xaxisTitle: `Densité (usagers/km HTA)`,
                        yaxisTitle: `Taux d'enfouissement HTA (%)`,
                        tooltipXaxisTitle: `Densité`,
                        tooltipXaxisUnit: `us./km HTA`,
                        tooltipYaxisTitle: `Taux d'enfouissement HTA`,
                        tooltipYaxisUnit: `%`,
                    },
                    mvNetworkTypeEvolutionChart: {
                        title: 'Evolution annuelle de la longueur totale des réseaux HTA (en km), et des proportions par typologie de réseaux en (%)',
                        descriptionTitle: 'Précision',
                        descriptionContent:
                            'Les technologies de réseaux HTA torsadés et HTA en galérie sont présentes dans les données de contrôle, mais absentes des CRAC. Ainsi les linéaires HTA torsadés sont compris dans les réseaux aériens, et les linéaires HTA en galerie dans les réseaux souterrains.',
                        undergroundRateAxisTitle: 'Taux de réseau HTA souterrain',
                        aerialRateAxisTitle: 'Taux de réseau HTA aérien',
                        networkLengthAxisTitle: 'Longueur totale des réseaux HTA',
                        yaxisTitleLeft: `Typologie de réseau (%)`,
                        yaxisTitleRight: `Longueur totale (km)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: '%',
                        precision: null,
                        units: ['%', '%', 'km'],
                    },
                    mvNetworkRenewalRateChart: {
                        title: "Evolution annuelle des linéaires HTA aériens traités en PDV jusqu'en 2022, et en RP à partir de 2023 (en km), et taux de réseaux aériens concernés",
                        descriptionTitle: 'Précision',
                        descriptionContent: `En quelques mots : la PDV (Prolongation de Durée de Vie) est un programme mis en place par Enedis (environ de 2012 à 2022), pour renouveler partiellement les réseaux HTA aériens, notamment les accessoires avec certains niveaux d'usures.<br/>
A partir de 2023, la RP (Rénovation Programmée) a remplacé la PDV, avec notamment des niveaux d'exigences de remplacement d'accessoires plus élevés.<br/>
La PDV entrainait une allongement de la durée d'amortissement comptable de 15 ans à partir de la date des travaux, pour la RP cet allongement est de 25 ans.<br/>
Ceci est un résumé très réduit, AEC se tient à la disposition des AODE pour apporter plus de précisions sur les caractéristiques des opérations d'Enedis en PDV ou RP.`,
                        reliablePdvLengthTitle: `Longueur HTA fiabilisée en PDV (dans l'année)`,
                        treatedPdvLengthTitle: `Longueur HTA traitée en PDV (dans l'année)`,
                        rpLengthTitle: `Longueur HTA traitée en RP (dans l'année)`,
                        pdvRateTitle: `Evolution du taux total de PDV (traités et fiabilisés cumulés) ou de RP, par rapport au linéaire total HTA aérien (en %) - Cumul fin d'exercice`,
                        precision: null,
                        ratePrecision: null,
                        yaxisTitleLeft: `Longueur HTA (km)`,
                        yaxisTitleRight: `Taux de PDV ou RP (en %)`,
                        xaxisTitle: `Exercices`,
                        units: ['km', 'km', 'km', '%'],
                    },
                    mvNetworkOmtEvolutionChart: {
                        title: "Evolution annuelle du nombre d'OMT (Organes de Manoeuvre Télécommandés) installés sur le réseau HTA et nombre moyen d'OMT par départ HTA",
                        descriptionTitle: 'Précision',
                        descriptionContent: `OMT : les Organes de Manœuvre Télécommandés permettent de piloter à distance le réseau public de distribution d'électricité, avec notamment pour objectif de réduire le temps d'intervention en cas d'incident sur la moyenne tension HTA.<br/>
Les OMT pilotés par les FAC (Fonctions Avancées de Conduite) peuvent en moins de 3 minutes et automatiquement, réduire le nombre d'usagers coupés par un incident HTA.<br/><br/>
1 OMT "hors bouclage" sur un départ est compté pour 1.<br/>
1 OMT de "bouclage" est compté pour 0,5 pour chacun des 2 départs pour lesquels il permet le bouclage.`,
                        omtMeanAxisTitle: "Nombre moyen d'OMT par départ HTA",
                        omtTotalAxisTitle: "Nombre total d'OMT ",
                        yaxisTitleLeft: `Nombre total d'OMT`,
                        yaxisTitleRight: `Nb moyen d'OMT par départ HTA`,
                        xaxisTitle: `Exercices`,
                    },
                    mvUndergroundingRateMap: {
                        title: "Carte du taux d'enfouissement HTA par commune (en %)",
                        descriptionTitle: 'Précision',
                        descriptionContent:
                            'Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.',
                    },
                },
            },
            aging: {
                path: 'aging',
                title: 'Age des réseaux HTA et points de vigilances',
                texts: {
                    mvNetworksAverageAge: {
                        title: 'Age moyen des réseaux HTA (en années)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            <p>
                                L'âge moyen des réseaux HTA, est calculé ainsi par AEC : il correspond à la moyenne des âges de chaque tronçon, avec une pondération selon la longueur de chaque tronçon.
                            </p>
                            <p>
                                L'âge de chaque tronçon correspond à la différence entre l'année traitée des données et l'année de mise en service du tronçon, à laquelle + 0,5 an (une demi-année) est ajoutée.
                            </p>
                            <p class="mb-0">
                                La demi-année ajoutée permet de faire une moyenne sur l'année, autrement dit que l'ouvrage ait été mis en service en janvier ou décembre de la même année, nous retenons une mise en service moyenne au 1er juillet.
                                Cela permet principalement d'éviter, par exemple, que tous les ouvrages mis en service en 2024, ait toujours un âge de 0 an à fin 2024.
                                AEC se tient à la disposition des AODE pour transmettre plus de précisions sur les modalités de calcul.
                            </p>`,
                        suffix: ' ans',
                        precision: 1,
                        badgeSuffix: ' ans',
                        badgePrecision: 2,
                    },
                    mvNetworksLengthOver40YearsOld: {
                        title: 'Longueur totale des réseaux HTA ayant plus de 40 ans (en km)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            Afin de préciser, l'indicateur "longueur totale des réseaux HTA ayant plus de 40 ans", correspond à strictement plus de 40 ans.
                        `,
                        precision: 0,
                        suffix: ' km',
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                    },
                    mvNetworksLengthCpi: {
                        title: 'Longueur totale des réseaux HTA souterrains de type CPI (en km)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            <p>
                                Les câbles souterrains HTA CPI (Câbles à isolation Papier Imprégné) correspondent à la 1ère génération de câbles souterrains HTA mise en service.
                                Ils ont été posés principalement entre 1960 et 1980. Après 1980 ce sont les câbles souterrains synthétiques qui ont été posés.
                            </p>
                            <p class="mb-0">
                                Le suivi des linéaires des câbles CPI HTA est souvent mis sous surveillance, car cette technologie qui a en moyenne plus de 40 ans, présente un taux d'incidents pour 100 km fréquemment très élevé.
                                Les CPI sont principalement situés dans les centres bourgs, secteurs dans lesquels les dépannages et travaux peuvent être complexes, et le nombre d'usagers coupés augmentent fortement en cas de double défaut.
                                Cette incidentologie est aggravée durant les périodes de fortes chaleurs estivales.
                            </p>
                        `,
                        suffix: ' km',
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                    },
                    mvNetworksLengthLowSection: {
                        title: 'Longueur totale des réseaux HTA aériens nus de Faibles Sections (en km)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            Les réseaux HTA aériens nus de Faibles Sections (FS) sont les conducteurs :
                            <ul class="mb-0">
                                <li>
                                    en cuivre avec des sections ≤ 14 mm² ;
                                </li>
                                <li>
                                    en aluminium avec des sections ≤ 22 mm².
                                </li>
                            </ul>
                        `,
                        suffix: ' km',
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                    },

                    mvNetworksAverageAgesChart: {
                        title: 'Evolution des âges moyens par technologie de réseau HTA (en années)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            <p>
                                L'âge moyen des réseaux HTA, est calculé ainsi par AEC : il correspond à la moyenne des âges de chaque tronçon, avec une pondération selon la longueur de chaque tronçon.
                            </p>
                            <p>
                                L'âge de chaque tronçon correspond à la différence entre l'année traitée des données et l'année de mise en service du tronçon, à laquelle + 0,5 an (une demi-année) est ajoutée.
                            </p>
                            <p class="mb-0">
                                La demi-année ajoutée permet de faire une moyenne sur l'année, autrement dit que l'ouvrage ait été mis en service en janvier ou décembre de la même année, nous retenons une mise en service moyenne au 1er juillet.
                                Cela permet principalement d'éviter, par exemple, que tous les ouvrages mis en service en 2024, ait toujours un âge de 0 an à fin 2024.
                                AEC se tient à la disposition des AODE pour transmettre plus de précisions sur les modalités de calcul.
                            </p>
                        `,
                        totalMvNetworkAgesAxisTitle: 'Age moyen HTA total',
                        overheadMvNetworkAgesAxisTitle: 'Age moyen HTA aérien',
                        undergroundCpiMvNetworkAgesAxisTitle: 'Age moyen HTA souterrain papier',
                        undergroundSyntheticMvNetworkAgesAxisTitle:
                            'Age moyen HTA souterrain synthétique',
                        precision: 1,
                        yaxisTitleLeft: `Age moyen (années)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: 'ans',
                    },

                    mvNetworksAgesComparisonChart: {
                        title: `Comparaison des âges moyens par technologie de réseau HTA (en années) de la concession avec les statistiques d'AEC`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                        <p>
                            Les âges moyens des réseaux HTA ne sont pas communiqués dans les CRAC annuels du distributeur.
                        </p>
                        <p class="mb-0">
                            Les statistiques d'AEC ont été calculées sur un panel d'une quarentaine de concessions, avec un minimum de 60 000 usagers.
                        </p>`,
                        serieLabel: 'Statistiques AEC',
                        aecMeanLabel: 'Moyenne AEC',
                        clientValueLabel: 'Valeur de la concession',
                        serieLabelAvg: 'Moyenne AEC',
                        serieLabelValue: 'Valeur de la concession',
                        precision: null,
                    },

                    mvNetworksLowSectionChart: {
                        title: `Evolution de la longueur totale du réseau HTA de Faible Section (FS) (en km)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                        Les réseaux HTA aériens nus de Faibles Sections (FS)  sont les conducteurs :
                            <ul class="mb-0"><li>en cuivre avec des sections ≤ 14 mm² ;</li>
                                <li>en aluminium avec des sections ≤ 22 mm².</li>
                            </ul>
                        `,
                        axisTitle: 'Longueur du réseau HTA de faible section',
                        axisTitleRate: 'Taux de réseau HTA de faible section',
                        ratePrecision: null,
                        yaxisTitleLeft: `Exercices`,
                        xaxisTitle: `Longueur totale (km)`,
                        unitTooltip: 'km',
                        precision: 1,
                    },
                    mvNetworksPaperChart: {
                        title: `Evolution de la longueur totale du réseau HTA CPI (en km)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                        <p>
                            Les câbles souterrains HTA CPI (Câbles à Isolation Papier Imprégné) correspondent à la 1ère génération de câbles HTA mise en service.
                            Ils ont été posés principalement entre 1960 et 1980. Après 1980 ce sont les câbles souterrains synthétiques qui ont été posés.
                        </p>
                        <p class="mb-0">
                            Le suivi des linéaires des câbles CPI HTA est souvent mis sous surveillance, car cette technologie qui a en moyenne plus de 40 ans, présente un taux d'incidents pour 100 km fréquemment très élevé.
                            Les CPI sont principalement situés dans les centres bourgs, secteur dans lesquels les dépannages et travaux peuvent être complexes, et le nombre d'usagers coupés augmentent fortement en cas de double défaut.
                            Cette incidentologie est aggravée durant les périodes de fortes chaleurs estivales.
                        </p>
                        `,
                        axisTitle: 'Longueur du réseau HTA CPI',
                        axisTitleRate: 'Taux de réseau HTA CPI',
                        ratePrecision: null,
                        yaxisTitleLeft: `Exercices`,
                        xaxisTitle: `Longueur totale (km)`,
                        unitTooltip: 'km',
                        precision: 1,
                    },
                    mvNetworksOver40Chart: {
                        title: `Evolution de la longueur totale du réseau HTA âgé de plus de 40 ans (en km)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `L'indicateur "longueur totale des réseaux HTA ayant plus de 40 ans", correspond à strictement plus de 40 ans.`,
                        axisTitle: 'Longueur du réseau HTA âgé de plus de 40 ans',
                        axisTitleRate: 'Taux de réseaux HTA âgé de plus de 40 ans',
                        ratePrecision: null,
                        yaxisTitleLeft: `Exercices`,
                        xaxisTitle: `Longueur totale (km)`,
                        unitTooltip: 'km',
                        precision: 0,
                    },
                    mvNetworksVigilancePointsChart: {
                        title: `Comparaison des taux de réseaux HTA sous vigilance particulière (en %) de la concession avec les statistiques d'AEC`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            Les taux de réseaux HTA en CPI ne sont pas communiqués dans les CRAC annuels du distributeur.
                            Les statistiques d'AEC ont été calculées sur un panel d'une quarantaine de concessions, avec un minimum de 60 000 usagers.
                        `,
                        serieLabel: 'Statistiques AEC',
                        aecMeanLabel: 'Moyenne AEC',
                        clientValueLabel: 'Valeur de la concession',
                        serieLabelAvg: 'Moyenne AEC',
                        serieLabelValue: 'Valeur de la concession',
                        precision: null,
                    },

                    mvNetworksCpiLengthMap: {
                        title: `Carte des longueurs par commune de réseaux HTA souterrains en CPI - Câbles Papiers Imprégnés (en km)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
                    },
                },
            },
        },
    },

    lvNetworks: {
        path: 'infrastructure/lv-networks',
        sidebarLabel: 'Réseaux BT',
        title: 'Ouvrages',
        subTitle: 'Réseaux BT',
        tabs: {
            undergrounding: {
                path: 'undergrounding',
                title: 'Enfouissement BT',
                texts: {
                    totalLvNetworkLength: {
                        title: 'Longueur totale des réseaux BT (en km)',
                        descriptionContent:
                            "Les réseaux BT (aériens ou souterrains) permettent depuis les postes HTA/BT d'alimenter tous les PDL BT (Points De Livraison), comprenant les usagers BT (inférieur et supérieur à 36 kVA) en soutirage, et aussi les producteurs BT. Leur niveau de tension nomimale est de 230 V en monophasé et 400 V en triphasé.",
                        suffix: ' km',
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    lvBurialRate: {
                        title: 'Taux d’enfouissement BT (en %)',
                        descriptionContent:
                            "Le taux d'enfouissement BT correspond à la proportion des réseaux BT souterrains par rapport aux linéaires totaux BT",
                        suffix: ' %',
                        precision: 1,
                        badgeSuffix: ' Points',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    lvFeedersCount: {
                        title: 'Nombre de départs BT de la concession',
                        suffix: ' km',
                        precision: 0,
                        badgePrecision: 0,
                        badgeSuffix: ' départs',
                    },
                    lvNetworkTypeProportionChart: {
                        title: 'Evolution annuelle de la longueur totale des réseaux BT (en km), et des proportions par typologie de réseaux (en %)',
                        descriptionContent: '.',
                        descriptionTitle: 'Précision',
                        networkLengthLvAxisTitle: 'Longueur totale des réseaux BT',
                        undergroundNetworkRateAxisTitle: 'Taux réseau BT souterrain',
                        overheadBareNetworkRateAxisTitle: 'Taux réseau BT aérien nu',
                        twistedOverheadNetworkRateAxisTitle: 'Taux réseau BT aérien torsadé',
                        precision: 1,
                        precisionKm: 0,
                        yaxisTitleLeft: `Typologie de réseau (%)`,
                        yaxisTitleRight: `Longueur totale (en km)`,
                        xaxisTitle: `Exercices`,
                        units: ['%', '%', '%', 'km'],
                        toolTipPrecision: [1, 1, 1, 0],
                    },
                    lvUndergroundRateChart: {
                        title: "Positionnement du taux d'enfouissement BT de la concession, selon la densité d'usagers (usagers/km BT) et par rapport aux taux des départements métropolitains",
                        descriptionContent: `Quatre départements d'Ile-de -France (75, 92, 93 et 94) sont exclus de ce benchmark.<br>
                                En effet, ces 4 départements avec des taux d'enfouissement BT moyen de 92% présentent des densités d'usagers comprises entre 170 et 400 usagers/km, qui sont très supérieurs au reste de l'hexagone, ce qui rendraient illisible le nuage de points.<br>
                                Le 5ème département au classement de la densité (et donc le maximum du benchmark) est le Val-d'Oise avec 110 usagers/km.`,
                        descriptionTitle: 'Précision',
                        lvUndergroundRateConcessionAxisTitle: 'Ma Concession',
                        lvUndergroundRatedepartmentCodeAxisTitle: 'Autres départements',
                        precision: 1,
                        tickStep: 25,
                        xmin: 0,
                        xmax: 200,
                        yaxisTitle: `Taux d'enfouissement BT (%)`,
                        xaxisTitle: `Densité (usagers/km BT)`,
                        tooltipXaxisTitle: `Densité`,
                        tooltipXaxisUnit: `us./km BT`,
                        tooltipYaxisTitle: `Taux d'enfouissement BT`,
                        tooltipYaxisUnit: `%`,
                    },
                    lvUndergroundingRateMap: {
                        title: 'Taux d’enfouissement BT par commune (en %)',
                        descriptionTitle: 'Précision',
                        descriptionContent:
                            'Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.',
                    },
                },
            },
            aging: {
                path: 'aging',
                title: 'Age des réseaux BT et points de vigilances',
                texts: {
                    lvAerialBareNetworkLength: {
                        title: 'Longueur des réseaux BT aériens nus (en km)',
                        suffix: ' km',
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                        descriptionTitle: '',
                    },
                    lvAerialBareFsNetworkLength: {
                        title: 'Longueur des réseaux BT aériens nus de Faible Section (en km)',
                        descriptionContent: `Les réseaux aériens nus de Faibles Sections (FS) BT sont les conducteurs : <br>
                                - en cuivre avec des sections ≤ 14 mm²<br>
                                - en aluminium avec des sections ≤ 22 mm². `,
                        suffix: ' km',
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    lvDefaultDated1946WorksRate: {
                        title: "Taux de linéaire BT dont l'année de mise en service est 1946 (en %)",
                        descriptionContent:
                            "Par le passé le concessionnaire n'enregistrait pas systématiquement les dates de mises en service (MES) des ouvrages BT dans sa base technique, notamment car les outils de l'époque n'étaient pas ceux d'aujourd'hui. Aussi pour les réseaux BT sans date de MES connue, l'année 1946 est inscrite par défaut dans la base technique, et sans aucun lien avec l'âge probable des ouvrages.",
                        suffix: ' %',
                        precision: 1,
                        badgeSuffix: ' points',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    lvNetworksAverageAgesChart: {
                        title: 'Evolution des âges moyens par technologie de réseau BT (en années)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            <p>
                                L'âge moyen des réseaux BT, est calculé ainsi par AEC : il correspond à la moyenne des âges de chaque tronçon, avec une pondération selon la longueur de chaque tronçon.
                            </p>
                            <p>
                                L'âge de chaque tronçon correspond à la différence entre l'année traitée des données et l'année de mise en service du tronçon, à laquelle + 0,5 an (une demi-année) est ajoutée.
                            </p>
                            <p class="mb-0">
                                La demi-année ajoutée permet de faire une moyenne sur l'année, autrement dit que l'ouvrage ait été mis en service en janvier ou décembre de la même année, nous retenons une mise en service moyenne au 1er juillet.
                                Cela permet principalement d'éviter, par exemple, que tous les ouvrages mis en service en 2024, ait toujours un âge de 0 an à fin 2024.
                                Cet âge moyen est calculé selon les données de la base technique, en gardant les années fictives 1946.
                                AEC se tient à la disposition des AODE pour transmettre plus de précisions sur les modalités de calcul.
                            </p>
                        `,
                        totalLvNetworkAgesAxisTitle: 'Age moyen BT total',
                        overheadLvNetworkAgesAxisTitle: 'Age moyen BT aérien nu',
                        twistedLvNetworkAgesAxisTitle: 'Age moyen BT torsadé',
                        undergroundLvNetworkAgesAxisTitle: 'Age moyen BT souterrrain',
                        precision: 1,
                        yaxisTitleLeft: `Age moyen (années)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: 'ans',
                    },
                    lvNetworksEvolOverheadChart: {
                        title: 'Evolution de la longueur des réseaux BT aériens nus (en km), par zone FACE',
                        bareOverheadLvLengthErAxisTitle: 'Réseau BT Aérien nu urbain',
                        bareOverheadLvLengthRuAxisTitle: 'Réseau BT Aérien nu rural',
                        precision: 1,
                        ratePrecision: null,
                        yaxisTitleLeft: `Années`,
                        xaxisTitle: `Longueur totale (km)`,
                        axisTitleRate: 'Taux total de réseaux BT nus',
                        unitTooltip: 'km',
                    },
                    lvNetworksEvolOverheadFsChart: {
                        title: 'Evolution de la longueur des réseaux BT aériens nus de Faibles Sections (FS) (en km), par zone FACE',
                        descriptionContent: `Les réseaux aériens nus de Faibles Sections (FS) BT sont les conducteurs :<br>
                            - en cuivre avec des sections ≤ 14 mm² ;<br>
                            - en aluminium avec des sections ≤ 22 mm². `,
                        descriptionTitle: 'Précision',
                        lowSectionLvLengthErAxisTitle: 'Réseau BT Aérien nu urbain',
                        lowSectionLvLengthRuAxisTitle: 'Réseau BT Aérien nu rural',
                        precision: null,
                        ratePrecision: null,
                        yaxisTitleLeft: `Années`,
                        xaxisTitle: `Longueur totale (km)`,
                        axisTitleRate: 'Taux total de réseaux BT nus FS',
                        unitTooltip: 'km',
                    },
                    lvNetworksRateComparisonChart: {
                        title: `Comparaison des taux de réseaux BT de la concession (en %) avec les statistiques disponibles`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                        <p>
                            Les taux par concession de réseaux BT de Faibles Sections et de 1946, ne sont pas communiqués dans les CRAC annuels du distributeur.
                        </p>
                        <p class="mb-0">
                            Les statistiques d'AEC pour ces deux taux ont été calculées sur un panel d'une quarantaine de concessions, avec un minimum de 60 000 usagers.
                            Les statistiques départementales relatives aux taux de réseaux BT aériens nus, torsadés et souterrains sont issues de l'Opendata d'Enedis.
                        </p>`,
                        serieLabel: 'Statistiques AEC',
                        aecMeanLabel: 'Moyenne AEC',
                        clientValueLabel: 'Valeur de la concession',
                        serieLabelAvg: 'Moyenne AEC',
                        serieLabelValue: 'Valeur de la concession',
                        precision: null,
                    },
                    lvAerialBareNetworkMap: {
                        title: 'Carte du taux de réseaux BT aériens nus par commune (en %)',
                        descriptionTitle: 'Précision',
                        descriptionContent:
                            'Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.',
                    },
                },
            },
        },
    },

    transformerStations: {
        path: 'infrastructure/transformer-stations',
        sidebarLabel: 'Autres',
        title: 'Ouvrages',
        subTitle: 'Autres ouvrages',
        tabs: {
            substationsTransformers: {
                path: 'substations-transformers',
                title: 'Postes et transformateurs HTA/BT',
                texts: {
                    numberLvMvStations: {
                        title: 'Nombre de postes HTA/BT',
                        descriptionContent:
                            'Les postes HTA/BT sont équipés de transformateurs qui permettent de convertir le niveau de tension du réseau HTA en amont vers le niveau de tension du réseau BT en aval.',
                        precision: 0,
                        badgeSuffix: ' postes',
                        badgePrecision: 0,
                        descriptionTitle: 'Précision',
                    },
                    numberLvMvTransformers: {
                        title: 'Nombre de transformateurs HTA/BT',
                        descriptionContent:
                            'Les transformateurs HTA/BT équipent les postes HTA/BT, la majorité des postes contiennent un seul transformateur, mais il existe des postes qui accueillent plusieurs transformateurs HTA/BT.',
                        precision: 0,
                        badgeSuffix: ' transfo.',
                        badgePrecision: 0,
                        descriptionTitle: 'Précision',
                    },
                    averageAgeStations: {
                        title: 'Age moyen des postes HTA/BT (en années)',
                        descriptionContent: `L'âge moyen des postes HTA/BT, est calculé ainsi par AEC : il s'agit de la différence entre l'année traitée des données et l'âge de mise en service du poste, à laquelle + 0,5 an (une demi-année) est ajoutée.<br>
                            La demi-année ajoutée permet de faire une moyenne sur l'année, autrement dit que l'ouvrage ait été mis en service en janvier ou décembre de la même année, nous retenons une mise en service moyenne au 1er juillet.<br>
                            Cela permet principalement d'éviter, par exemple, que tous les postes mis en service en 2024, ait toujours un âge de 0 an à fin 2024.<br>
                            AEC se tient à la disposition des AODE pour transmettre plus de précisions sur les modalités de calcul.`,
                        suffix: ' ans',
                        precision: 1,
                        badgeSuffix: ' ans',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    averageAgeTransformers: {
                        title: 'Age moyen des transformateurs HTA/BT (en années)',
                        descriptionContent: `L'âge moyen des transformateurs HTA/BT, est calculé ainsi par AEC : il s'agit de la différence entre l'année traitée des données et l'année de fabrication du transformateur, à laquelle + 0,5 an (une demi-année) est ajoutée.<br>
                            La demi-année ajoutée permet de faire une moyenne sur l'année, autrement dit que l'ouvrage ait été mis en service en janvier ou décembre de la même année, nous retenons une mise en service moyenne au 1er juillet.<br>
                            Cela permet principalement d'éviter, par exemple, que tous les transformateurs mis en service en 2024, ait toujours un âge de 0 an à fin 2024.<br>
                            AEC se tient à la disposition des AODE pour transmettre plus de précisions sur les modalités de calcul.`,
                        suffix: ' ans',
                        precision: 1,
                        badgeSuffix: ' ans',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    lvMvEvolutionStationsChart: {
                        title: 'Evolution de la répartition de la quantité de postes HTA/BT par type',
                        poleMountedStationsAxisTitle: 'Postes sur poteau',
                        masonryStationsAxisTitle: 'Postes maçonnés',
                        prefabricatedStationsAxisTitle: 'Postes préfabriqués',
                        totalTitle: 'Total du nombre de postes',
                        precision: null,
                        yaxisTitleLeft: `Nombre de postes`,
                        xaxisTitle: `Exercices`,
                    },
                    transformersGenerationChart: {
                        title: 'Evolution de la répartition des transformateurs par génération',
                        yaxisTitle: 'Nombre de Transformateurs HTA/BT',
                        transformers400AxisTitle: 'Nombre de transformateurs 400V',
                        transformers410AxisTitle: 'Nombre de transformateurs 410V',
                        totalTitle: 'Nombre total de transformateurs',
                        yaxisTitleLeft: `Nombre de transformateurs HTA/BT`,
                        xaxisTitle: `Exercices`,
                        precision: null,
                    },
                    highCabinsChart: {
                        title: 'Evolution de la répartition des cabines hautes par zone FACE',
                        yaxisTitle: 'Nombre de cabines hautes',
                        ruralHighCabinsAxisTitle: 'Nombre de cabines hautes ER',
                        urbanHighCabinsAxisTitle: 'Nombre de cabines hautes RU',
                        totalTitle: 'Nombre total de cabines hautes',
                        yaxisTitleLeft: `Nombre de postes cabines hautes`,
                        xaxisTitle: `Exercices`,
                        precision: null,
                    },
                    transformersMeanAgeChart: {
                        title: 'Evolution des âges moyens par technologie de postes et de transformateurs',
                        yaxisTitle: 'Age moyen',
                        transformersMeanAgeAxisTitle: 'Transformateurs',
                        substationsMeanAgeAxisTitle: 'Tous postes confondus',
                        poleMountedSubstationsMeanAgeAxisTitle: 'Postes sur poteau',
                        masonrySubstationsMeanAgeAxisTitle: 'Postes maçonnés',
                        prefabSubstationsMeanAgeAxisTitle: 'Postes préfabriqués',
                        yaxisTitleLeft: `Ages moyens (années)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: 'ans',
                        precision: 1,
                    },
                    urbanRuralSubstationsChart: {
                        title: 'Répartition du nombre de postes HTA/BT selon les régimes urbain et rural',
                        urbanSubstationsTitle: 'Nombre de postes HTA/BT RU',
                        ruralSubstationsTitle: 'Nombre de postes HTA/BT ER',
                        precision: 1,
                    },
                },
            },
            meters: {
                path: 'meters',
                title: 'Compteurs',
                texts: {
                    numberLinkyMeters: {
                        title: 'Nombre de compteurs Linky C5 installés',
                        descriptionContent:
                            "Après une expérimentation en 2015, les compteurs communiquants Linky ont été déployés pour les usagers C5 à l'échelle nationale à partir 2016, pour remplacer les générations de compteurs précédentes (électromécaniques et électroniques).",
                        precision: 0,
                        badgeSuffix: ' %',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    deploymentRate: {
                        title: 'Taux de déploiement des compteurs Linky C5 (en %)',
                        suffix: ' %',
                        precision: 1,
                        badgeSuffix: ' points',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    communicatingMetersRate: {
                        title: 'Taux de compteurs Linky C5 communicants (en %)',
                        descriptionContent: `Dans les données de contrôle du concessionnaire, cet indicateur se nomme "Taux de compteurs Linky déclarés communicants dans Ginko".<br>
                            Et dans le CRAC, ce même indicateur se nomme "Nombre de PDL ouverts à tous les services Linky"`,
                        suffix: ' %',
                        precision: 1,
                        badgeSuffix: ' points',
                        badgePrecision: 1,
                        descriptionTitle: 'Précision',
                    },
                    metersTypologyChart: {
                        title: `Graphique de l'évolution de la typologie des appareils de comptage de la concession, pour les usagers C5`,
                        precision: null,
                        series: [
                            {
                                name: 'Compteurs Linky',
                                precision: null,
                            },
                            {
                                name: 'Autres compteurs',
                                precision: null,
                            },
                            {
                                name: 'Nombre total de compteurs Linky C5',
                                precision: null,
                            },
                        ],
                        yaxisTitleLeft: `Nombre total de compteurs C5`,
                        yaxisTitleRight: `Taux de compteurs par typologie (%)`,
                        xaxisTitle: `Exercices`,
                    },
                    linkyDeploymentRateComparisonChart: {
                        title: "Comparaison du taux de déploiement des compteurs Linky C5 de la concession (en %) avec les statistiques d'AEC",
                        descriptionTitle: 'Précision',
                        descriptionContent: `Le taux de déploiement des compteurs Linky C5 est bien communiqué dans les CRAC annuels du distributeur.
Les statistiques d'AEC pour ce taux ont été calculées sur un panel de plus de 90 concessions, avec un minimum de 60 000 usagers.`,
                        serieLabel: 'Statistiques AEC',
                        aecMeanLabel: 'Moyenne AEC',
                        clientValueLabel: 'Valeur de la concession',
                        serieLabelAvg: 'Moyenne AEC',
                        serieLabelValue: 'Valeur de la concession',
                        precision: null,
                    },
                    linkyMeterDeploymentRateMap: {
                        title: 'Carte du taux de déploiement des compteurs C5 Linky par commune (en %)',
                        descriptionTitle: 'Précision',
                        descriptionContent:
                            'Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.',
                    },
                },
            },
        },
    },

    continuityQuality: {
        path: 'continuity-quality/supply-continuity',
        icon: 'bi bi-activity',
        sidebarLabel: 'Continuité fourniture',
        title: 'Continuité et qualité de fourniture',
        subTitle: 'Continuité de fourniture',
        tabs: {
            bCriterion: {
                path: 'b-criterion',
                title: 'Critères B',
                texts: {
                    hixBCriterion: {
                        title: 'Critère B HIX (en minutes)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                                Le Critère B correspond à la durée moyenne annuelle d'interruption de fourniture par usager BT.
                                <br/>
                                Il comprend les interruptions pour incidents sur les réseaux HTA et BT, et pour travaux sur les réseaux HTA et BT. Il comprend également les interruptions sur le réseau de transport RTE et dans les Postes Sources.
                                La spécifité B HIX (Hors Evènements Exceptionnels) précise que les interruptions exceptionnelles sont exclues selon la définition de la CRE dans le TURPE (évènements climatiques de grande ampleur, vols de métaux, etc.)
                        `,
                        suffix: ' minutes',
                        precision: 1,
                        badgeSuffix: ' minutes',
                        badgePrecision: 1,
                    },
                    tccBCriterion: {
                        title: 'Critère B TCC (en minutes)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            Le Critère B TCC (Toutes Causes Confondues) correspond au critère  B avec la totalité des interruptions de fourniture, donc au critère B HIX auquel sont ajoutés les temps moyen de coupure classés exceptionnels.
                            Le Critère B TCC comprend les causes suivantes : travaux et incidents, HTA et BT, Postes Sources et Transport, et les coupures qualifiées en "exceptionnelles").<br>
                        Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.
                        `,
                        suffix: ' minutes',
                        precision: 1,
                        badgeSuffix: ' minutes',
                        badgePrecision: 1,
                    },
                    incidentBCriterion: {
                        title: 'Critère B incidents HIX (en minutes)',
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            Le critère B incidents HIX prend uniquement en compte les interruptions pour incidents BT et incidents HTA. (les interruptions pour travaux, incidents exceptionnels, au poste source et du transport sont donc exclues).
                        `,
                        suffix: ' minutes',
                        precision: 1,
                        badgeSuffix: ' minutes',
                        badgePrecision: 1,
                    },
                    BCriterionBreakdownChart: {
                        title: 'Evolution et décomposition du critère B de la concession (en minutes)',
                        series: [
                            {
                                name: 'Incidents HTA',
                            },
                            {
                                name: 'Incidents BT',
                            },
                            {
                                name: 'Travaux HTA',
                            },
                            {
                                name: 'Travaux BT',
                            },
                            {
                                name: 'Transport',
                            },
                            {
                                name: 'Postes Sources',
                            },
                            {
                                name: 'Critère B HIX',
                            },
                            {
                                name: 'Critère B TCC',
                            },
                        ],
                        yaxisTitleLeft: `Critère B (minutes)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: 'min.',
                    },
                    BCriterionEnedisInvestmentChart: {
                        title: 'Croisement du critère B HIX et des investissements "modernisation du réseau" d\'Enedis (hors déploiement Linky)',
                        series: [
                            {
                                name: `Critère B HIX (hors RTE) - Concession`,
                                precision: 0,
                            },
                            {
                                name: `Critère B HIX (hors RTE) - National`,
                                precision: 0,
                            },
                            {
                                name: `Ratio d'investissement - Concession`,
                                precision: 0,
                            },
                            {
                                name: `Ratio d'investissement - National`,
                                precision: 0,
                            },
                        ],
                        yaxisTitleLeft: `Critère B HIX hors RTE (minutes)`,
                        yaxisTitleRight: `Investissements (€/us.)`,
                        xaxisTitle: `Exercices`,
                        precision: 0,
                    },
                    meanTccBCriterionMap: {
                        title: `Critère B TCC par commune - moyenne des exercices N-2 à N (en minutes)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `Le Critère B TCC comprend les causes suivantes : travaux et incidents, HTA et BT, Postes Sources et Transport, et les coupures qualifiées en "exceptionnelles").
                            Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
                    },
                    meanHixBCriterionMap: {
                        title: `Critère B incidents HIX par commune - moyenne des exercices N-2 à N (en minutes) (comprenant : incidents HTA, incidents BT et incidents Postes Sources)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
                    },
                    tccBCriterionMap: {
                        title: `Critère B TCC par commune - dernier exercice N (en minutes) (comprenant : travaux et incidents, HTA et BT, Postes Sources et Transport, et les coupures qualifiées en "exceptionnelles")`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
                    },
                    hixBCriterionMap: {
                        title: `Critère B incidents HIX par commune - dernier exercice N (en minutes) (comprenant : incidents HTA, incidents BT et incidents Postes Sources)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
                    },
                },
            },
            outages: {
                path: 'outages-frequency',
                title: 'Fréquence de coupure',
                texts: {
                    qualityDecree: {
                        title: `Taux d'usagers (BT et HTA) de la concession au-delà des seuils sur la continuité de fourniture`,
                        seriesTitle: [
                            `Taux d'usagers au-delà du seuil du Décret Qualité (volet continuité)`,
                            `Seuil du taux de clients en dépassement 5%`,
                        ],
                        precision: null,
                        yaxisTitleLeft: `Taux d'usagers (%)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: '%',
                        thresholdExceedance: 5,
                    },
                    outagesFrequency: {
                        title: `Fréquence de coupures longues, brèves et très brèves HTA par usager`,
                        seriesTitle: ['CL (> 3min)', 'CB (1s < durée < 3min)', 'CTB (< 1s)'],
                        precision: null,
                        yaxisTitleLeft: `Ratio de coupures (nombre par usager)`,
                        xaxisTitle: `Exercices`,
                        unitTooltip: 'coupures/us.',
                    },
                    outagesComparison: {
                        title: `Comparaison des fréquences de coupure HIX (CL, CB, CTB) de la concession avec les statistiques d'AEC (en nombre moyen de coupures par usager)`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `
                            <p>
                                Les statistiques d'AEC pour ces ratios ont été calculées sur un panel d'une quarantaine de concessions, avec un minimum de 60 000 usagers.
                            </p>
                            <p>
                                En outre, les fréquences Coupures Très Brèves (CTB), ne sont pas transmises dans les CRAC, alors que c'est bien le cas pour les fréquences de Coupures Longues (CL) et de Coupures Brèves (CB).
                            </p>
                            <p class="mb-0">
                                La méthodologie de calcul des fréquences de coupures CL, CB et CTB, n'est pas strictement identique entre AEC et Enedis, ce qui peut expliquer parfois de légers écarts.
                            </p>
                        `,
                        seriesTitle: 'Intervalle entre min et max AEC',
                        serieLabel: 'Statistiques AEC',
                        aecMeanLabel: 'Moyenne AEC',
                        categories: ['CL par usager', 'CB par usager', 'CTB par usager'],
                        clientValueLabel: 'Valeur de la concession',
                        serieLabelAvg: 'Moyenne AEC',
                        serieLabelValue: 'Valeur de la concession',
                        precision: null,
                    },
                },
            },
            incidentology: {
                path: 'incidentology',
                title: 'Incidentologie',
                texts: {
                    mvIncident: {
                        title: `Evolution du nombre d'incidents HTA pour 100 km de réseaux (HIX)`,
                        seriesTitle: ['Aérien', 'Souterrain', 'Total', 'CPI'],
                        precision: null,
                        yaxisTitleLeft: `Aériens & Soute. Synthétiques (pour 100 km)`,
                        yaxisTitleRight: `Souterrains CPI (pour 100 km)`,
                        xaxisTitle: `Exercices`,
                    },
                    lvIncident: {
                        title: `Evolution du nombre d'incidents BT pour 100 km de réseaux (HIX)`,
                        seriesTitle: ['Aérien nu', 'Torsadé', 'Souterrain', 'Total'],
                        precision: null,
                        yaxisTitleLeft: `Souterrains & Torsadés (pour 100 km)`,
                        yaxisTitleRight: `Aériens Nus (pour 100 km)`,
                        xaxisTitle: `Exercices`,
                    },
                    incidentComparison: {
                        title: `Comparaison des taux d'incidents HIX pour 100 km de réseaux par technologie de la concession avec les statistiques d'AEC`,
                        descriptionTitle: 'Précision',
                        descriptionContent: `Les statistiques d'AEC pour ces ratios ont été calculées sur un panel d'une quarantaine de concessions, avec un minimum de 60 000 usagers.`,
                        seriesTitle: 'Intervalle entre min et max AEC',
                        serieLabel: 'Statistiques AEC',
                        aecMeanLabel: 'Moyenne AEC',
                        categories: [
                            'HTA aérien',
                            ['HTA souterrain', 'synthétique'],
                            ['HTA souterrain', 'CPI'],
                            'HTA total',
                            'BT aérien',
                            'BT aérien torsadé',
                            'BT souterrain',
                            'BT total',
                        ],
                        clientValueLabel: 'Valeur de la concession',
                        serieLabelAvg: 'Moyenne AEC',
                        serieLabelValue: 'Valeur de la concession',
                        precision: null,
                    },
                },
            },
        },
    },

    voltageQuality: {
        path: 'continuity-quality/voltage-quality',
        sidebarLabel: 'Qualité tension',
        title: 'Continuité et qualité de fourniture',
        subTitle: 'Qualité de tension',
        texts: {
            mvDeparturesRateAbove5Percent: {
                title: 'Taux de départs HTA avec une contrainte de tension maximale supérieure ou égale à 5% (en %)',
                descriptionContent: '',
                precision: 1,
                suffix: ' %',
                badgeSuffix: ' points',
                badgePrecision: 1,
            },
            lvCmaRate: {
                title: `Taux d'usagers BT considérés mal alimentés (CMA) (en %)`,
                descriptionContent: `Le taux d'usagers considérés CMA est le ratio entre le nombre de CMA et le nombre total d'usagers BT.`,
                precision: 1,
                suffix: ' %',
                badgeSuffix: ' points',
                badgePrecision: 2,
                descriptionTitle: 'Précision',
            },
            numberOfLvCma: {
                title: `Nombre d'usagers BT CMA`,
                descriptionContent: `Un client est considéré comme mal alimenté (CMA) si, au moins une fois dans l’année, la tension à son point de livraison atteint une valeur efficace inférieure à 90 % de la valeur de la tension nominale ou supérieure à 110 % de cette tension nominale.
                    Le nombre de clients CMA est issu d'un calcul par le concessionnaire selon plusieurs paramètres, mais à ce jour il ne s'agit pas d'une mesure à chaque PDL.`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            numberOfLvDma: {
                title: 'Nombre de Départs BT considérés Mal Alimentés (DMA)',
                descriptionContent: `A partir de 1 usager CMA sur un départ BT, le départ BT l'alimentant est considéré Départ Mal Alimenté (DMA)`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            voltageQualityComparisonChart: {
                title: `Comparaison des indicateurs relatifs à la Qualité de Fourniture (QF) de la concession avec les statistiques d'AEC`,
                descriptionTitle: 'Précision',
                descriptionContent: `
                    Les indicateurs sont disponibles dans les CRAC.<br>
                    Les statistiques d'AEC pour ces ratios ont été calculées sur un panel de plus de 90 concessions, avec un minimum de 60 000 usagers.`,
                serieLabel: 'Statistiques AEC',
                aecMeanLabel: 'Moyenne AEC',
                clientValueLabel: 'Valeur de la concession',
                serieLabelAvg: 'Moyenne AEC',
                serieLabelValue: 'Valeur de la concession',
                precision: null,
            },
            evolutionMvDepartCtAbove5PercentChart: {
                title: 'Evolution du nombre et du taux de départs HTA avec une contrainte de tension maximale supérieure à 5 %',
                nbrMvDepartMaxCT5And7PercentAxisTitle: 'Départs HTA mal alimentés de 5 à 7 %',
                nbrMvDepartMaxCTAbove7PercentAxisTitle: 'Départs HTA mal alimentés à plus de 7 %',
                rateMvDepartCtAbove5PercentAxisTitle: 'Taux départs HTA mal alimentés > 5 %',
                precision: 0,
                ratePrecision: 1,
                yaxisTitleLeft: `Nombre de départs HTA`,
                yaxisTitleRight: `Taux de départ HTA (%)`,
                xaxisTitle: `Exercices`,
            },
            evolutionNbrLvDepartPoorChart: {
                title: 'Evolution du nombre de départs BT mal alimentés (DMA)',
                nbrLvDepartPoorErAxisTitle: 'Nombre de DMA BT ER',
                nbrLvDepartPoorRuAxisTitle: 'Nombre de DMA BT RU',
                totalDmaTitle: 'Nombre total de DMA',
                rateDmaAllZoneAxisTitle: 'Taux DMA toutes zones confondues',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Nombre de départs DMA BT`,
                yaxisTitleRight: `Taux de DMA BT (%)`,
                xaxisTitle: `Exercices`,
            },
            evolutionNbrRateCmaChart: {
                title: 'Evolution du nombre et du taux de clients mal alimentés (CMA)',
                nbrClientPoorErAxisTitle: 'Nombre de CMA ER',
                nbrClientPoorRuAxisTitle: 'Nombre de CMA RU',
                totalCmaTitle: 'Nombre total de CMA',
                rateCmaTotAxisTitle: 'Taux de CMA BT',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Nombre de départs CMA BT`,
                yaxisTitleRight: `Taux de départ CMA BT (%)`,
                xaxisTitle: `Exercices`,
            },
            lvCmaRateMap: {
                title: `Carte du taux de clients BT considérés Mal Alimentés (CMA BT) par commune (en %)`,
                descriptionTitle: 'Précision',
                descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
            },
            mvDeparturesTable: {
                title: 'Liste des 10 départs HTA avec les chutes de tension annuelles maximales les plus élevées (année n)',
                sourceStationNameTitle: 'Nom du poste source',
                departureNameTitle: 'Nom du départ HTA',
                maxVoltageDropTitle: 'Chute de tension maximale (n) en %',
                previousYearMaxVoltageDropTitle: 'Chute de tension maximale (n-1) en %',
            },
            substationCmaTable: {
                title: 'Liste des 10 postes HTA/BT avec les nombres de CMA les plus élevés (année n)',
                cityNameTitle: 'Nom de la commune',
                inseeCodeTitle: 'Code INSEE',
                subStationNameTitle: 'Nom du poste HTA/BT',
                gdoCodeTitle: 'Code GDO',
                categoryTitle: 'Classification ER/RU',
                cmaCountTitle: 'Nombre de CMA (n)',
                previousYearCmaCountTitle: 'Nombre de CMA (n - 1)',
            },
        },
    },

    investments: {
        path: 'expenses/investments',
        icon: 'bi bi-cone-striped',
        sidebarLabel: 'Investissements (CAPEX)',
        title: "Dépenses d'Enedis",
        subTitle: 'Investissements (CAPEX)',
        texts: {
            totalInvestments: {
                title: `Dépenses totales d'investissements du concessionnaire (CAPEX) (en M€)`,
                descriptionContent: `Les investissements présentés ici sont ceux indiqués dans le CRAC remis à l'AODE.<br>
                    Le total rassemble toutes les catégories de dépenses par le concessionnaire :<br>
                               <ul class="mb-0">
                                    <li> Modernisation et performance du réseau (dont les compteurs Linky jusqu'en 2022)</li>
                                    <li> Exigences environnementales et  des contraintes externes (y compris contribution "article 8")</li>
                                    <li> Logistique</li>
                                    <li> Raccordements des utilisateurs consommateurs et producteurs (y compris contribution à la PCT)</li>
                                </ul>`,
                precision: 1,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            includingPsInvestments: {
                title: `Investissements (CAPEX) pour les postes sources (en M€)`,
                precision: 1,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
            },
            connectionInvestments: {
                title: `Investissements (CAPEX) pour les raccordements (en M€)`,
                descriptionContent: `Les investissements "raccordements" rassemblent les dépenses pour les producteurs et consommateurs (HTA et BT).
                    Depuis 2023, ils prennent également en compte les dépenses pour les poses des compteurs Linky.`,
                precision: 1,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            networkPerformanceInvestments: {
                title: 'Investissements (CAPEX) pour la performance et la modernisation du réseau, hors Linky (en M€)',
                descriptionContent: `Les investissements pour la performance et la modernisation du réseau rassemblent les :
                <ul class="mb-0">
                    <li> renforcements (BT et HTA) </li>
                    <li> amélioration de la résilience des réseaux et des postes (dont PAC - Plan Aléas Climatiques);</li>
                    <li> amélioration de la fiabilité des réseaux et des postes ;</li>
                    <li> opérations de Prolongation de Durée de Vie (PDV) ou de Rénovation Programmée (RP) ;</li>
                    <li> moyens d'exploitation.</li>
                </ul>

En revanche, contrairement au CRAC, AEC a fait le choix d'exclure les dépenses relatives au déploiement des compteurs Linky (afin que les dépenses soient comparables sur de grandes périodes).`,
                precision: 1,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            dealerInvestmentAmountsChart: {
                title: 'Montants des investissements du concessionnaire (en M€)',
                totalAxisTitle: 'Nombre de clients mal alimentés ER',
                connectionAxisTitle: 'Raccordements',
                networkPerformanceAxisTitle: `Modernisation et performance réseau (hors Linky)`,
                securityEnvironmentAxisTitle: `Exigences règlementaires`,
                logisticsAxisTitle: 'Logistique',
                includingSourceStationsAxisTitle: 'Postes Sources',
                investmentsLinkySmartGridAxisTitle: 'Déploiement compteurs Linky et SmartGrids',
                totalTitle: 'Montant total',
                precision: 1,
                yaxisTitleLeft: `Dépenses d'investissements (M€)`,
                xaxisTitle: `Exercices`,
            },
            lengthMvServiceStructureChart: {
                title: `Longueurs HTA mises en service par type d'ouvrage (en km)`,
                totalAxisTitle: 'Total',
                undergroundAxisTitle: 'Souterrain',
                twistedAxisTitle: `Torsadé`,
                overheadBareAxisTitle: `Aérien nu`,
                totalTitle: 'Longueur totale',
                precision: null,
                yaxisTitleLeft: `Longueurs HTA (km)`,
                xaxisTitle: `Exercices`,
                unitTooltip: `km`,
            },
            lengthMvServiceWorkChart: {
                title: `Longueurs HTA mises en service par nature de travaux (en km)`,
                totalAxisTitle: 'Total',
                extensionAxisTitle: 'Extension',
                renewalAxisTitle: `Renouvellement`,
                reinforcementAxisTitle: `Renforcement`,
                totalTitle: 'Longueur totale',
                precision: null,
                yaxisTitleLeft: `Longueurs HTA (km)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'km',
            },
            lengthLvServiceStructureChart: {
                title: `Longueurs BT mises en service par type d'ouvrage (en km)`,
                totalAxisTitle: 'Total',
                undergroundAxisTitle: 'Souterrain',
                twistedAxisTitle: `Torsadé`,
                overheadBareAxisTitle: `Aérien nu`,
                totalTitle: 'Longueur totale',
                precision: null,
                yaxisTitleLeft: `Longueurs BT (km)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'km',
            },
            lengthLvServiceWorkChart: {
                title: `Longueurs BT mises en service par nature de travaux (en km)`,
                totalAxisTitle: 'Total',
                extensionAxisTitle: 'Extension',
                renewalAxisTitle: `Renouvellement`,
                reinforcementAxisTitle: `Renforcement`,
                totalTitle: 'Longueur totale',
                precision: null,
                yaxisTitleLeft: `Longueurs BT (km)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'km',
            },
            amountsNetworkPerfChart: {
                title: `Montants des investissements des sous-catégories de "performance et modernisation du réseau" en M€ (hors Linky)`,
                totalAxisTitle: 'Total',
                reinforcementLvAxisTitle: 'Renforcement des réseaux BT',
                reinforcementMvAxisTitle: `Renforcement des réseaux HTA`,
                actionsPacAxisTitle: `Actions visant à améliorer la résilience des réseaux et des postes (PAC)`,
                actionsExcluPdvRpAxisTitle: `Actions visant à améliorer la fiabilité des réseaux et des postes (hors PDV/RP)`,
                actionsPdvRpAxisTitle: `Actions visant à améliorer la fiabilité des réseaux et des postes (PDV/RP)`,
                operatingResourcesAxisTitle: `Moyens d'exploitations`,
                totalTitle: 'Montant total',
                precision: null,
                yaxisTitleLeft: `Montants des investissements (M€)`,
                xaxisTitle: `Exercices`,
            },
            amountsConnectionChart: {
                title: `Montants des investissements des sous-catégories de raccordements (en M€)`,
                totalAxisTitle: 'Montant total des investissements de raccordement',
                consumersLvAxisTitle: 'Consommateurs BT',
                consumersMvAxisTitle: `Consommateurs HTA`,
                producersLvAxisTitle: 'Producteurs BT',
                producersMvAxisTitle: `Producteurs HTA`,
                totalTitle: 'Montant total',
                precision: null,
                yaxisTitleLeft: `Montants des investissements (M€)`,
                xaxisTitle: `Exercices`,
            },
        },
    },

    maintenanceCost: {
        path: 'expenses/maintenance-cost',
        sidebarLabel: 'Entretien et maintenance (OPEX)',
        title: "Dépenses d'Enedis",
        subTitle: 'Entretien et maintenance (OPEX)',
        texts: {
            evolutionExpenditureChart: {
                title: `Evolution des dépenses pour l'élagage (en k€) et des longueurs traitées en élagage (en km)`,
                amountWorksAxisTitle: `Montants consacrés aux travaux d'élagage (k€)`,
                lenghtNetworksAxisTitle: 'Longueur de réseaux (HTA et BT) traitée (km)',
                precision: null,
                yaxisTitleLeft: `Dépenses pour l'élagage  (k€)`,
                yaxisTitleRight: `Longueur réseaux HTA & BT (km)`,
                xaxisTitle: `Exercices`,
            },
        },
    },
    kpis: {
        path: 'accounting/kpis',
        icon: 'bi bi-graph-up-arrow',
        sidebarLabel: 'Indicateurs comptables',
        title: 'Comptabilité',
        subTitle: 'Indicateurs comptables',
        texts: {
            totalGrossValue: {
                title: 'Valeur Brute (VB) totale (en M€)',
                descriptionContent: `La Valeur Brute correspondant à la valeur d'origine des ouvrages`,
                precision: 0,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            grossValuePerUserRatio: {
                title: `Ratio de Valeur Brute par usager (en €/us.)`,
                descriptionContent: ``,
                precision: 0,
                suffix: ' €/us.',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: '',
            },
            totalRenewalProvision: {
                title: `Provisions pour Renouvellement (PR) totale (en M€)`,
                descriptionContent: `Les provisions pour renouvellement (PR) ont été constituées sous forme de dotation par le concessionnaire pour les ouvrages renouvelables avant la fin du contrat de concession ("modèle 1992"). Elles permettent de couvrir la différence entre la valeur brute d'origine du bien et son coût futur de remplacement à l'identique.<br>
                    Elles ne peuvent être utilisées que pour renouveler l'ouvrage pour lequel elles ont été constituées.<br>
                    Depuis les entrées en vigueur progressives des contrats de concession selon le "modèle 2017", les dotations aux PR n'existent plus. Mais les PR constituées dans le précédent contrat restent utilisées pour être affectées dans le cadre de renouvellement d'ouvrages.`,
                precision: 0,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            overallDepreciationRate: {
                title: `Taux global d'amortissement (en %)`,
                descriptionContent: `Le taux global d'amortissement correpond au rapport entre la valeur totale de l'amortissement des ouvrages et la valeur brute totale.`,
                precision: 1,
                badgeSuffix: ' points',
                suffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            evolutionFixedAssetsChart: {
                title: `Evolution des immobilisations en concession (en M€)`,
                totalValueNetBookAxisTitle: `Total de la Valeur Nette Comptable (VNC)`,
                totalDepreciationAxisTitle: 'Total des amortissements',
                totalGrossValueAxisTitle: 'Valeur brute totale',
                precision: null,
                xaxisTitle: `Exercices`,
                yaxisTitle: `Immobilisations en concession (M€)`,
                axisTitleRate: `Valeur Brute Totale`,
            },
            grossValueEvolChart: {
                title: `Evolution de la valeur brute par usager (en €/usager)`,
                valueGrossUserAxisTitle: `Valeur brute par usager (en €/us.)`,
                precision: null,
                xaxisTitle: `Exercices`,
                yaxisTitle: `Valeur brute par usager (€/us.)`,
            },
            rateDeprWorkEvolChart: {
                title: `Evolution du taux d'amortissement total des ouvrages concédés (en %)`,
                totalRateDepreWorksAxisTitle: `Taux d'amortissement total des ouvrages concédés`,
                precision: 1,
                xaxisTitle: `Exercices`,
                yaxisTitle: `Taux d'amortissement total (%)`,
                unitTooltip: '%',
            },
            rateDeprWorksFamilyChart: {
                title: `Taux d'amortissement par famille d'ouvrages (en %)`,
                yearCurrentAxisTitle: `N`,
                yearPreviousAxisTitle: `N-1`,
                precision: null,
                xaxisTitle: `Exercices`,
                yaxisTitle: `Taux d'amortissement (%)`,
            },
            grossValueRatioComparisonChart: {
                title: `Comparaison du ratio de Valeur Brute (VB) par usager (€/usager) de la concession avec les statistiques d'AEC`,
                descriptionTitle: 'Précision',
                descriptionContent: `
                    Les indicateurs sont disponibles dans les CRAC.<br>
                    Les statistiques d'AEC pour ces ratios ont été calculées sur un panel de plus de 90 concessions, avec un minimum de 60 000 usagers.`,
                serieLabel: 'Statistiques AEC',
                aecMeanLabel: 'Moyenne AEC',
                clientValueLabel: 'Valeur de la concession',
                serieLabelAvg: 'Moyenne AEC',
                serieLabelValue: 'Valeur de la concession',
                precision: null,
                unitTooltip: '€/us.',
            },
            grossValueBreakdownChart: {
                title: "Répartition de la valeur brute par type d'ouvrage",
                labels: [
                    'Autres biens non localisés',
                    'Autres biens localisés',
                    'Disjoncteurs',
                    "Compteurs marché d'affaires",
                    'Compteurs Linky',
                    'Comptage non localisé',
                    'DI aéro-souterraines et souterraines',
                    'LR aéro-souterraines et souterraines',
                    'Branchements (LR & DI) aériens',
                    'OCB',
                    'Ouvrages de branchement NL',
                    'Transformateurs HTA/BT',
                    'Concentrateurs Linky',
                    'Postes HTA/BT',
                    'Réseau BT Souterrain',
                    'Réseau BT Torsadé',
                    'Réseau BT Aérien Nu',
                    'Réseau HTA Souterrain',
                    'Réseau HTA Aérien',
                ],
                precision: 1,
                unitTooltip: 'M€',
            },
            depreciationRateComparisonChart: {
                title: `Comparaison du taux d'amortissement global (en %) de la concession avec les statistiques d'AEC`,
                descriptionTitle: 'Précision',
                descriptionContent: `
                    Les indicateurs sont disponibles dans les CRAC.<br>
                    Les statistiques d'AEC pour ces ratios ont été calculées sur un panel de plus de 90 concessions, avec un minimum de 60 000 usagers.
                `,
                serieLabel: 'Statistiques AEC',
                aecMeanLabel: 'Moyenne AEC',
                clientValueLabel: 'Valeur de la concession',
                serieLabelAvg: 'Moyenne AEC',
                serieLabelValue: 'Valeur de la concession',
                precision: null,
                unitTooltip: '%',
            },
            replacementValueChart: {
                title: `Evolution de la valeur de remplacement totale (en M€) et des coefficients de revalorisation (en %)`,
                series: [
                    {
                        name: `Valeur de remplacement totale (en M€)`,
                        tooltipName: `Valeur de remplacement totale`,
                        unit: 'M€',
                        precision: null,
                    },
                    {
                        name: `Coefficients annuels de revalorisation des réseaux (en %)`,
                        tooltipName: `Coefficients annuels de revalorisation des réseaux`,
                        unit: '%',
                        precision: null,
                        stepSize: 1,
                    },
                ],
                precision: null,
                yaxisTitleLeft: `Valeur de remplacement totale (M€) `,
                yaxisTitleRight: `Coefficients annuels de revalorisation (en %)`,
                xaxisTitle: `Exercices`,
            },
            totalProvisionChart: {
                title: `Evolution du total des provisions pour renouvellement (en M€)`,
                series: [
                    {
                        name: `Provisions pour renouvellement totales (en M€)`,
                        tooltipName: `Provisions pour renouvellement totales`,
                        unit: 'M€',
                        precision: null,
                    },
                ],
                precision: null,
                yaxisTitle: `Provisions pour renouvellement totales (M€)`,
                xaxisTitle: `Exercices`,
            },
            provisionsDistributionChart: {
                title: `Répartition des provisions pour renouvellement constituées par type d'ouvrage`,
                labels: [
                    `Compteurs (tous confondus)`,
                    `OCB`,
                    'Branchements Individuels',
                    `Réseaux HTA`,
                    `Transformateurs HTA/BT`,
                    `Postes HTA/BT et Concentrateurs Linky`,
                    `Réseaux BT`,
                    `Autres biens (OL et ONL)`,
                ],
                precision: 1,
                unitTooltip: 'M€',
            },
        },
    },
    grantorRights: {
        path: 'accounting/grantor-rights',
        sidebarLabel: 'Droits du concédant',
        title: 'Comptabilité',
        subTitle: 'Droits du concédant',
        texts: {
            evolutionOriginFinancingChart: {
                title: `Evolution de l'origine de financement de la Valeur Nette Comptable (VNC) des mises en service (en M€)`,
                rateNetBookAxisTitle: `Taux VN Enedis`,
                rateNetBookCommuAxisTitle: 'Taux VN Collectivités et tiers',
                totalNetBookAxisTitle: 'Total M€',
                precision: null,
                yaxisTitle: `Origine de financement de la VNC (M€)`,
                xaxisTitle: `Exercices`,
                units: ['%', '%', 'M€'],
            },
            distribSourcesFinanChart: {
                title: 'Répartition des origines de financement des ouvrages mis en concession sur le dernier exercice',
                communitiesTrdPartTitle: 'Collectivités et Tiers',
                enedisTitle: 'Enedis',
                unitTooltip: 'M€',
                precision: 1,
            },
            evolGrantorRightsChart: {
                title: `Evolution des droits du concédant (en M€)`,
                grantorRightsAxisTitle: 'Total droits du concédant',
                precision: null,
                yaxisTitle: `Droits du concédant (M€)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'M€',
            },
            breakdownGrChart: {
                title: `Décomposition des droits du concédant sur le dernier exercice (en M€)`,
                netValueWorksAxisTitle: 'Valeur nette totale des ouvrages',
                amortiFinanAxisTitle: 'Amortissement sur les financements concédant',
                unamortizedValueAxisTitle:
                    'Valeur non amortie des ouvrages financés par le concessionnaire',
                grantorRightsAxisTitle: 'Droits du concédant',
                precision: null,
            },
            evolDebtsChart: {
                title: `Evolution des dettes et créances (D&C) réciproques (en M€)`,
                maxHistoryYears: 5,
                series: [
                    {
                        name: 'Amortissement sur les financements concédant',
                        precision: null,
                    },
                    {
                        name: 'Provisions pour renouvellement',
                        precision: null,
                    },
                    {
                        name: 'Valeur non amortie des ouvrages financés par le concessionnaire',
                        precision: null,
                    },
                    {
                        name: 'Résultante',
                        precision: null,
                    },
                ],
                depreciationGrantorAxisTitle: 'Amortissement sur les financements concédant',
                provisionRenewalAxisTitle: 'Provisions pour renouvellement',
                undepreciatedValueAxisTitle:
                    'Valeur non amortie des ouvrages financés par le concessionnaire',
                resultingAxisTitle: 'Résultante',
                precision: null,
                yaxisTitleLeft: `Composantes des D&C réciproques`,
                yaxisTitleRight: `Solde des D&C réciproques (M€)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'M€',
            },
        },
    },
    operatingAccount: {
        path: 'operating-account',
        icon: 'bi bi-currency-euro',
        sidebarLabel: "Compte d'exploitation",
        title: "Compte d'exploitation",
        subTitle: '',
        texts: {
            totalOperatingRevenueAmount: {
                title: `Montant total des produits d'exploitation (en M€)`,
                descriptionContent: `Les produits d'exploitation inclus : <br>
                            <ul class="mb-0">
                                <li>Recettes d’acheminement ;</li>
                                <li>Autres recettes;</li>
                                <li>Production stockée et immobilisée;</li>
                                <li>Reprises sur amortissements et provisions; </li>
                                <li>Autres produits divers</li>
                            </ul>
                        Une partie des produits est native à la concession, et une autre partie est issue de clés de répartition appliquées à des montants supra-concessifs.`,
                precision: 0,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            totalOperatingExpensesAmount: {
                title: `Montant total des charges d'exploitation (en M€)`,
                descriptionContent: `Les charges d'exploitation inclues :
                        <ul class="mb-0">
                             <li>Accès réseau amont ;</li>
                             <li>Achats d’énergie pour couvrir les pertes sur le réseau ;</li>
                             <li>Redevances de concession ;</li>
                             <li>Autres consommations externes ;</li>
                             <li>Impôts, taxes et versements assimilés ;</li>
                             <li>Charges de personnel ;</li>
                             <li>Dotation aux amortissements ;</li>
                        </ul><br>
                            <p class="mb-0">
                            Une partie des charges est native à la concession, et une autre partie est issue de clés de répartition appliquées à des montants supra-concessifs.
                            </p>
                            <ul class="mb-0">
                                <li>Dotation aux provisions pour renouvellement ;</li>
                                <li>Autres dotations d’exploitation ;</li>
                                <li>Autres charges ;</li>
                                <li>Charges centrales.</li>
                            </ul>
                            `,
                precision: 0,
                suffix: ' M€',
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            actualConcessionMarginRate: {
                title: `Taux de marge constaté sur la concession (sans prise en compte de la contribution à l'équilibre) (en %)`,
                descriptionContent: `Le taux de marge "constaté" donne une indication sur une équivalence de rentabilité de la concession (rapport entre le résultat "constaté" et le chiffre d'affaires de la concession).<br>
                    Le taux de marge "affiché" est identique quelle que soit la concession considérée. Ce taux de marge "affiché" est également identique à celui de la société Enedis. Il prend en compte la contribution à l'équilibre.`,
                precision: 1,
                suffix: ' %',
                badgeSuffix: ' points',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            displayedConcessionMarginRate: {
                title: `Taux de marge affiché sur la concession (après prise en compte de la contribution à l'équilibre) (en %)`,
                descriptionContent: `Le taux de marge "constaté" donne une indication sur une équivalence de rentabilité de la concession (rapport entre le résultat "constaté" et le chiffre d'affaires de la concession).<br>
                Le taux de marge "affiché" est identique quelle que soit la concession considérée. Ce taux de marge "affiché" est également identique à celui de la société Enedis. Il prend en compte la contribution à l'équilibre.`,
                precision: 1,
                suffix: ' %',
                badgeSuffix: ' points',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            mainKeyDistributedAmounts: {
                title: 'Clé de répartition principale des montants répartis (prorata du nombre de clients)',
                descriptionContent: `Le seul compte d’exploitation de la société Enedis est présenté à la maille nationale<br>
                        Les éléments financiers d’exploitation présentés dans le CRAC sont un recalcul pour s’approcher d’une vision concession.<br>
                        Cette vision est un cumul d’éléments financiers natifs à la concession, avec des éléments financiers nationaux ou régionaux auxquels des clés de répartition sont appliquées.<br>
                        Sans être l’unique clé utilisée, la principale clé de répartition est le « prorata du nombre de clients », par rapport à la maille de la Direction Régionale (DR d'Enedis).`,
                precision: 1,
                suffix: ' %',
                badgeSuffix: ' points',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            operatingProductsEvolutionChart: {
                title: "Evolution des produits d'exploitation (M€)",
                connectionFees: 'Recettes de raccordements et prestations',
                storedAndCapitalizedProduction: 'Production stockée et immobilisée',
                transportRevenues: "Recettes d'acheminement",
                depreciationReversals: 'Reprises sur amortissements et provisions',
                otherOperatingIncome: "Autres produits d'exploitation",
                totalTitle: 'Total des produits',
                precision: null,
                yaxisTitleLeft: `Produits d'exploitation (M€)`,
                xaxisTitle: `Exercices`,
                axisTitleTotal: 'Total des produits',
                unitTooltip: 'M€',
            },
            operatingCostsEvolutionChart: {
                title: "Evolution des charges d'exploitation (M€)",
                otherCosts: 'Autres charges',
                upstreamNetworkAccessAndLossPurchases:
                    'Accès réseau amont et achats des pertes sur réseau de distribution',
                centralCosts: 'Charges centrales',
                taxesAndContributions: 'Impôts, taxes, redevances, contribution',
                personnelCosts: 'Charges de personnel',
                depreciationAndProvisions: 'Dotations aux amortissements et provisions',
                totalTitle: 'Total des charges',
                precision: null,
                yaxisTitleLeft: `Charges d'exploitation (M€)`,
                xaxisTitle: `Exercices`,
                axisTitleTotal: 'Total des charges',
                unitTooltip: 'M€',
            },
            operatingResultEvolutionChart: {
                title: 'Evolution du résultat (en M€)',
                displayedResult:
                    "Résultat affiché (avec prise en compte de la contribution à l'équilibre)",
                actualResult:
                    "Résultat constaté (sans prise en compte de la contribution à l'équilibre)",
                precision: null,
                yaxisTitleLeft: `Résultats annuels (M€)`,
                xaxisTitle: `Exercices`,
            },
            operatingMarginRateEvolutionChart: {
                title: 'Evolution du taux de marge (en %)',
                actualMarginRate: 'Taux de marge "constaté" de la concession',
                displayedMarginRate: 'Taux de marge "affiché" de la concession',
                precision: null,
                yaxisTitleLeft: `Taux de marge annuels (%)`,
                xaxisTitle: `Exercices`,
            },
        },
    },
    energyUsers: {
        path: 'enedis-customers/energy-users',
        icon: 'bi bi-plugin',
        sidebarLabel: 'Usagers en soutirage',
        title: 'Gestion clientèle - Enedis',
        subTitle: 'Usagers en soutirage',
        texts: {
            usersCount: {
                title: "Nombre total d'usagers en soutirage",
                descriptionContent: `Le nombre total d'usagers rassemble les usagers BT < 36 kVA, BT > 36 kVA et HTA.`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            totalConsumption: {
                title: 'Consommation totale des usagers en soutirage',
                descriptionContent: `Giga Watt heure (GWh) et kilo Watt heure (kWh) sont les unités de mesure de la consommation électrique.
1 GWh = 1 000 000 kWh`,
                suffix: ' GWh',
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            totalIncome: {
                title: "Recette totale d'acheminement",
                precision: 0,
                suffix: ' M€ HT',
                badgeSuffix: ' %',
                badgePrecision: 1,
            },
            numberLvMvUserEvolutionChart: {
                title: "Evolution du nombre d'usagers BT et HTA",
                rateAnnualGrowthAxisTitle: `Taux de croissance annuelle du nombre total d'usagers en soutirage`,
                usersLvLess36AxisTitle: 'Usagers BT ≤ 36kVA',
                usersLvGeater36AxisTitle: 'Usagers BT > 36kVA',
                usersMvAxisTitle: 'Usagers HTA',
                totalTitle: 'Total',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Nombre d'usagers`,
                yaxisTitleRight: `Taux de croissance annuelle (%)`,
                xaxisTitle: `Exercices`,
            },
            consumptionUserEvolutionChart: {
                title: 'Evolution de la consommation totale des usagers (en GWh)',
                series: [
                    {
                        name: 'Usagers BT≤ 36kVA',
                        precision: null,
                    },
                    {
                        name: 'Usagers BT> 36kVA',
                        precision: null,
                    },
                    {
                        name: 'Usagers HTA',
                        precision: null,
                    },
                    {
                        name: 'Total',
                        precision: null,
                    },
                    {
                        name: 'Taux de croissance annuelle de la consommations totale',
                        precision: null,
                    },
                ],
                precision: null,
                yaxisTitleLeft: `Consommation (GWh)`,
                yaxisTitleRight: `Taux de croissance annuelle (%)`,
                xaxisTitle: `Exercices`,
            },
            meanConsumptionChart: {
                title: 'Evolution de la consommation moyenne des usagers (en MWh/us.) - Echelle logarithmique',
                lvUsersUnder36Title: 'Usager BT ≤ 36kVA',
                lvUsersOver36Title: 'Usager BT>  36kVA',
                mvUsersTitle: 'Usager HTA',
                precision: null,
                yaxisTitleLeft: `Consommation moyenne (MWh/us.)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'MWh/us.',
            },
            transportRevenuesChart: {
                title: "Evolution des recettes totales d'acheminement (en M€ HT)",
                lvUsersUnder36Title: 'Usagers BT ≤ 36kVA',
                lvUsersOver36Title: 'Usagers BT > 36kVA',
                mvUsersTitle: 'Usagers HTA',
                totalTitle: 'Recettes acheminement total concession',
                totalEvolutionTitle: 'Evolution des recettes acheminement total concession',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Recettes d'acheminement (M€ HT)`,
                yaxisTitleRight: `Taux de croissance annuelle (%)`,
                xaxisTitle: `Exercices`,
            },
            meanKwhPriceChart: {
                title: "Evolution du montant moyen d'acheminement du kWh (en c€ HT/kWh)",
                lvUsersUnder36Title: 'Usager BT ≤ 36 kVA',
                lvUsersOver36Title: 'Usager BT > 36 kVA',
                mvUsersTitle: 'Usager HTA',
                precision: null,
                yaxisTitleLeft: `Montant moyen d'acheminement (c€ HT/kWh)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'c€ HT/kWh',
            },
            energyUsersMap: {
                title: `Nombre total d'usagers en soutirage par commune`,
                descriptionTitle: 'Précision',
                descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
            },
        },
    },
    energyProducers: {
        path: 'enedis-customers/energy-producers',
        sidebarLabel: 'Usagers producteurs',
        title: 'Gestion clientèle - Enedis',
        subTitle: 'Usagers producteurs',
        texts: {
            producersNumberTotal: {
                title: 'Nombre total de producteurs raccordés au réseau de distribution (HTA et BT)',
                descriptionContent: `Le nombre total de producteurs rassemble les injections BT < 36 kVA, BT > 36 kVA et HTA, qui ont un contrat d'obligation d'achat actif.<br>
                Depuis 2022, ce nombre total intègre également, selon le distributeur, les auto-consommateurs qui ont communiqués leur attestation.`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            powerTotal: {
                title: 'Puissance totale producteurs raccordés au réseau de distribution (HTA et BT) en MVA',
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
            },
            facilitiesDistributionChart: {
                title: "Evolution de la répartition du nombre d'installations de production par type d'énergie (hors installations photovoltaïques)",
                hydraulicTitle: 'Hydraulique',
                windTitle: 'Eolien',
                othersTitle: 'Autres (Biogaz, biomasse, géothermie, etc.)',
                yaxisTitleLeft: `Nombre de producteurs (hors PV)`,
                yaxisTitleRight: `Taux de producteurs PV (en %)`,
                xaxisTitle: `Exercices`,
            },
            facilitiesEvolutionChart: {
                title: "Evolution du nombre total d'installations de production et évolution de la part des installations photovoltaïques",
                series: [
                    {
                        name: 'Nombre total de producteurs',
                        precision: null,
                    },
                    {
                        name: 'Taux producteurs PV par rapport au nombre total',
                        precision: null,
                    },
                ],
                photovoltaicTitle: 'Taux producteurs PV par rapport au nombre total',
                totalTitle: 'Nombre total de producteurs',
                yaxisTitleLeft: `Nombre total de producteurs`,
                yaxisTitleRight: `Taux de producteurs PV (%)`,
                xaxisTitle: `Exercices`,
            },
            facilitiesPowerEvolutionChart: {
                title: 'Puissances totales des installations de productions (en MVA)',
                hydraulicTitle: 'Hydraulique',
                windTitle: 'Eolien',
                othersTitle: 'Autres (Biogaz, biomasse, géothermie, etc.)',
                photovoltaicTitle: 'Photovoltaïque',
                totalTitle: 'Puissance totale',
                yaxisTitleLeft: `Puissances totales (en MVA)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'MVA',
            },
        },
    },
    connections: {
        path: 'enedis-customers/connections',
        sidebarLabel: 'Raccordements',
        title: 'Gestion clientèle - Enedis',
        subTitle: 'Raccordements',
        texts: {
            connectionsWithdrawalTotal: {
                title: `Nombre total de raccordements en soutirage terminés dans l'année (HTA et BT)`,
                descriptionContent: `Le nombre total de raccordements en soutirage intègre :
                <ul>
                    <li> raccordements BT individuels sans adaptation de réseau ; </li>
                    <li> raccordements BT collectifs sans adaptation de réseau ; </li>
                    <li> raccordements BT individuels et collectifs avec adaptation de réseau ; </li>
                    <li> BT et de puissance comprise entre 36 et 250 kVA ; </li>
                    <li> HTA. </li>
                </ul>`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            connectionsInjectionTotal: {
                title: `Nombre total de raccordements en injection terminés dans l'année (HTA et BT)`,
                descriptionContent: `Le nombre total de raccordements en injection intègre :
                <ul>
                        <li> Raccordements BT ≤ à 36 kVA sans adaptation de réseau ;</li>
                        <li> Raccordements BT ≤ à 36 kVA avec adaptation de réseau ;</li>
                        <li> Raccordements BT compris entre 36 et 250 kVA ;</li>
                        <li> Raccordements HTA ≥ 250 kVA.</li>
                </ul>`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            connectionsInfraNumber: {
                title: 'Nombre de raccordements des infrastructures de recharge de véhicules électriques (IRVE)',
                descriptionContent: `Les raccordements des infrastructures de recharge de véhicules électriques (IRVE) sont également comptés dans les raccordements en soutirage.`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            powerInjectionConnections: {
                title: `Puissance annuelle des raccordements en injection terminés dans l'année (HTA et BT) (en kVA)`,
                descriptionContent: `Le nombre total de producteurs rassemble les injections BT < 36 kVA, BT > 36 kVA et HTA, qui ont un contrat d'obligation d'achat actif.<br>
                Depuis 2022, ce nombre total intègre également, selon le distributeur, les auto-consommateurs qui ont communiqués leur attestation.`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
            },
            connectionsCountChart: {
                title: `Evolution du nombre de raccordements (HTA et BT) en SOUTIRAGE dans l'année`,
                series: [
                    {
                        name: `BT < 36 kVA collectif`,
                    },
                    {
                        name: `BT < 36 kVA avec adaptation`,
                    },
                    {
                        name: `BT > 36 kVA`,
                    },
                    {
                        name: `Total`,
                    },
                    {
                        name: `BT < 36 kVA individuel`,
                    },
                    {
                        name: `HTA`,
                    },
                ],
                yaxisTitleLeft: `Raccordements (hors BT<36 sans adapt.)`,
                yaxisTitleRight: `Raccordements (BT<36 sans adapt. & total)`,
                xaxisTitle: `Exercices`,
            },
            connectionsProducersCountChart: {
                title: `Evolution du nombre de raccordements en INJECTION et de la puissance raccordée dans l'année (en kVA)`,
                series: [
                    {
                        name: `BT < 36 kVA sans adaptation`,
                    },
                    {
                        name: `BT < 36 kVA avec adaptation`,
                    },
                    {
                        name: `BT > 36 kVA`,
                    },
                    {
                        name: `HTA`,
                    },
                    {
                        name: `Total`,
                    },
                    {
                        name: `Puissance totale des producteurs raccordés dans l'année (kVA)`,
                    },
                ],
                yaxisTitleLeft: `Nombre de raccordements en INJECTION`,
                yaxisTitleRight: `Puissance raccordée dans l'année (kVA)`,
                xaxisTitle: `Exercices`,
                precision: 0,
            },
            connectionsEstimationNoticeChart: {
                title: `Evolution du délai moyen de production d'un devis de raccordement sans adaptation (en jours)`,
                series: [
                    {
                        name: `Soutirage BT < 36 kVA sans adaptation`,
                        precision: 0,
                    },
                    {
                        name: `Producteurs BT < 36 kVA sans adaptation`,
                        precision: 0,
                    },
                ],
                yaxisTitleLeft: `Délai moyen (jours)`,
                xaxisTitle: `Exercices`,
                precision: 1,
            },
            connectionsCommissioningRateChart: {
                title: `Graphiques de l'évolution des indicateurs de qualité de service de raccordement`,
                series: [
                    {
                        name: [
                            `Taux de MES sur installations existantes`,
                            `dans les délais catalogues (soutirage) - C5RES`,
                        ],
                    },
                    {
                        name: [
                            `Taux de respect du délai de production du devis de`,
                            `raccordement (soutirage, BT < 36 kVA,`,
                            `sans adaptation)`,
                        ],
                    },
                    {
                        name: [
                            `Taux de respect du délai de production du devis`,
                            `de raccordement (injection, BT < 36 kVA,`,
                            `sans adaptation)`,
                        ],
                    },
                    {
                        name: [
                            `Taux d'accessibilité téléphonique`,
                            `au service producteurs d'électricité`,
                        ],
                    },
                    {
                        name: [`Taux d'accessibilité téléphonique`, `au service raccordement`],
                    },
                ],
                precision: null,
            },
        },
    },
    enedisQuality: {
        path: 'enedis-customers/quality',
        sidebarLabel: 'Qualité Enedis',
        title: 'Gestion clientèle - Enedis',
        subTitle: "Indicateurs de qualité de service d'Enedis",
        texts: {
            commissioningRate: {
                title: `Taux de mise en service, sur installations existantes dans les délais standards pour les usagers C5 RES (en %)`,
                description: {
                    title: `Precision`,
                    content: `
                        <p>
                            Le distributeur intervient pour le compte de la totalité des fournisseurs pour réaliser les prestations prévues au catalogue.
                            Les mises en service sur installations existantes pour les usagers C5 RES (Résidentiel) font partie de ce catalogue.
                        </p>
                        <p class="mb-0">
                            Les demandes de 1ères mises en service (par exemple, suite à la construction d'une maison) ne sont pas intégrées dans cet indicateur.
                        </p>
                    `,
                },
                precision: 1,
                suffix: '%',
            },
            unpaidDisconnectionCount: {
                title: `Nombre de coupures effectives pour impayés réalisées par le distributeur pour les usagers C5 RES`,
                description: {
                    title: `Precision`,
                    content: `
                        <p>
                            Le distributeur intervient pour le compte de la totalité des fournisseurs pour réaliser les prestations prévues au catalogue.
                            Les interventions pour impayés pour les usagers C5 RES (Résidentiel) font partie de ce catalogue.
                            Lors de situations d'impayés détectées par un fournisseur, le distributeur réalise l'intervention demandée par le fournisseur.
                        </p>
                        <p>
                           Depuis 2022, le fournisseur EDF ne demande plus de coupures, mais uniquement des réductions de puissance (non prises en compte dans cet indicateur).
                            Les autres fournisseurs peuvent demander des coupures (selon le Décret dit "Impayés" en vigueur). Certaines demandes de coupures n'ont pas lieu, car le client a réglé sa dette entre temps ou sur place.
                        </p>
                        <p class="mb-0">
                            Une coupure pour impayés est qualifiée "d'effective" lorsque le process a été jusqu'à la dernière étape, à savoir une interruption réelle de l'alimentation électrique.
                        </p>
                    `,
                },
                precision: 0,
            },
        },
    },
    enedisClaims: {
        path: 'enedis-customers/claims',
        sidebarLabel: 'Réclamations Enedis',
        title: 'Gestion clientèle - Enedis',
        subTitle: 'Réclamations traitées par Enedis',
        texts: {
            volumeComplaints: {
                title: 'Nombre total de réclamations traitées par Enedis (écrites et orales, tous segments clientèles)',
                descriptionContent: `Dans le volume total de réclamations répondues par Enedis, le distributeur intégre toutes les réclamations, c'est-à-dire :
                <ul>
                <li>tous canaux de réception confondus (téléphone, mail, Internet et courrier) ;</li>
                <li>tous segments d'usagers confondus (consommateurs, producteurs, BT ou HTA) ;</li>
                <li>et tous niveaux de réclamation confondus (1er niveau et Instance d'Appel).</li>
                </ul>`,
                precision: 0,
                badgeSuffix: ' %',
                badgePrecision: 1,
                descriptionTitle: 'Précision',
            },
            responseComplaintsRate: {
                title: 'Taux de réponse par le distributeur aux réclamations sous 15 jours calendaires (en %)',
                precision: 1,
                suffix: ' %',
                badgeSuffix: ' points',
                badgePrecision: 1,
            },
            evolComplaintsEnedisChart: {
                title: `Evolution de la répartition des réclamations traitées par Enedis (écrites et orales) par item (1er niveau et instance d'appel confondus)`,
                connectionAxisTitle: 'Raccordement',
                receptionAxisTitle: 'Accueil',
                readingInvoicingAxisTitle: 'Relève et facturation',
                technicalInterventionAxisTitle: 'Intervention technique',
                qualitySupplyAxisTitle: 'Qualité de fourniture',
                linkyInstallationAxisTitle: 'Pose Linky',
                totalTitle: 'Total',
                precision: null,
                yaxisTitleLeft: `Nombre de réclamations traitées`,
                xaxisTitle: `Exercices`,
            },
            evolRateResponseComplaintsChart: {
                title: `Evolution du taux de réponse aux réclamations sous 15 jours par Enedis`,
                rateComplaintsAxisTitle: 'Taux de réclamations traitées sous 15 jours',
                precision: null,
                yaxisTitleLeft: `Taux de réponse (%)`,
                xaxisTitle: `Exercices`,
            },
            evolRateComplaintsUserChart: {
                title: `Graphique de l'évolution du taux de réclamations traitées par Enedis pour 10 000 usagers`,
                rateComplaintsAxisTitle:
                    'Taux de réclamations traitées par Enedis pour 10 000 usagers',
                precision: 0,
                yaxisTitleLeft: `Taux de réclamations traitées (‱)`,
                xaxisTitle: `Exercices`,
            },
            rateClaimsComparisonChart: {
                title: `Comparaison du taux de réclamations traitées par Enedis pour 10 000 usagers de la concession avec les statistiques d'AEC`,
                descriptionTitle: 'Précision',
                descriptionContent: `
                    Les indicateurs sont disponibles dans les CRAC.<br>
                    Les statistiques d'AEC pour ces ratios ont été calculées sur un panel de plus de 90 concessions, avec un minimum de 60 000 usagers.`,
                serieLabel: 'Statistiques AEC',
                aecMeanLabel: 'Moyenne AEC',
                clientValueLabel: 'Valeur de la concession',
                serieLabelAvg: 'Moyenne AEC',
                serieLabelValue: 'Valeur de la concession',
                precision: null,
            },
            enedisClaimRateMap: {
                title: `Carte du taux de réclamations traitées par Enedis pour 10 000 usagers, par commune`,
                descriptionTitle: 'Précision',
                descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
            },
        },
    },
    trvUsers: {
        path: 'edf-customers/trv-users',
        icon: 'bi bi-headset',
        sidebarLabel: 'Clients au TRV',
        title: 'Gestion clientèle - EDF',
        subTitle: 'Clients au TRV',
        texts: {
            userCount: {
                title: `Nombre total de clients aux TRV chez EDF`,
                description: {
                    title: `Precision`,
                    content: `
                        <p>
                            Le nombre total de clients aux TRV (Tarifs Règlementés de Vente) rassemble les clients aux Tarifs Bleus (TB), aux Tarifs Jaunes (TJ) et aux Tarifs Verts (TV).
                        </p>
                        <p class="mb-0">
                            Les clients ayant souscrit une offre de marché (OM) chez EDF ou chez un fournisseur alternatif ne peuvent pas être présentés, car ils sont en dehors du champ d'application du contrat de concession.
                        </p>
                    `,
                },
                precision: 0,
                maxRate: 100,
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
            },
            consumption: {
                title: `Consommation totale des clients aux TRV (en GWh)`,
                description: {
                    title: `Precision`,
                    content: `
                        <div>
                            Giga Watt heure (GWh) et kilo Watt heure (kWh) sont les unités de mesure de la consommation électrique.
                        </div>
                        <div>
                            1 GWh = 1 000 000 kWh
                        </div>
                    `,
                },
                precision: 0,
                suffix: ' GWh',
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
            },
            totalIncome: {
                title: `Recette totale de fourniture des TRV (en M€ HT)`,
                description: {
                    title: `Precision`,
                    content: `
                        <div>
                            Les recettes sont exprimées hors contribution et taxes (CTA, TICFE, TLCFE, TVA).
                        </div>
                        <div>
                            Par conséquent, les valeurs présentées ici ne rendent pas compte de la baisse du taux de TICFE décidée par les pouvoirs publics dans le cadre du bouclier tarifaire en 2023.
                        </div>
                    `,
                },
                precision: 0,
                suffix: ' M€',
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
            },
            userRate: {
                title: `Taux d'usagers BT ayant soucrit un contrat aux TRV (en %)`,
                description: {
                    title: `Precision`,
                    content: `
                        <div>
                            Le taux d'usagers aux TRV est un ratio estimé par AEC.
                        </div>
                        <div>
                            Il s'agit du ratio du nombre de clients aux tarifs bleu d'EDF par rapport au nombre d'usagers BT < 36 kVA d'Enedis.
                        </div>
                    `,
                },
                precision: 1,
                suffix: ' %',
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
            },
            usersCountChart: {
                title: `Evolution du nombre total de clients aux TRV`,
                series: [
                    {
                        name: `Tarifs Bleus`,
                        precision: null,
                    },
                    {
                        name: `Tarifs Jaunes`,
                        precision: null,
                    },
                    {
                        name: `Tarifs Verts`,
                        precision: null,
                    },
                    {
                        name: 'Total',
                        precision: null,
                    },
                    {
                        name: `Taux d'usagers BT aux TRV`,
                        precision: null,
                    },
                ],
                yaxisTitleLeft: `Nombre de clients aux TRV`,
                yaxisTitleRight: `Taux d'usagers BT aux TRV`,
                xaxisTitle: `Exercices`,
            },
            consumptionsChart: {
                title: `Evolution de la consommation totale des clients aux TRV (en GWh)`,
                precision: null,
                series: [
                    {
                        name: `Tarifs Bleus`,
                        precision: null,
                    },
                    {
                        name: `Tarifs Jaunes`,
                        precision: null,
                    },
                    {
                        name: `Tarifs Verts`,
                        precision: null,
                    },
                    {
                        name: 'Total',
                        precision: null,
                    },
                    {
                        name: `Taux de croissance annuelle de la consommations totale`,
                        precision: null,
                    },
                ],
                yaxisTitleLeft: `Consommation (GWh)`,
                yaxisTitleRight: `Evolution annuelle (%)`,
                xaxisTitle: `Exercices`,
            },
            meanConsumptionsChart: {
                title: `Evolution de la consommation moyenne des clients aux TRV (en MWh)`,
                series: [
                    {
                        name: `Tarifs Bleus`,
                    },
                    {
                        name: `Tarifs Jaunes`,
                    },
                    {
                        name: `Tarifs Verts`,
                    },
                ],
                yaxisTitleLeft: `Consommation moyenne (MWh/us.)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'MWh/us.',
                yaxisPrecision: 1,
            },
            incomeChart: {
                title: `Evolution de la recette totale de fourniture aux TRV (M€ HT)`,
                precision: null,
                series: [
                    {
                        name: `Tarifs Bleus`,
                    },
                    {
                        name: `Tarifs Jaunes`,
                    },
                    {
                        name: `Tarifs Verts`,
                    },
                    {
                        name: `Total`,
                    },
                    {
                        name: `Taux de croissance annuelle des recettes totales de founiture`,
                    },
                ],
                yaxisTitleLeft: `Recettes de fourniture (M€ HT)`,
                xaxisTitle: `Exercices`,
                units: ['M€ HT', 'M€ HT', 'M€ HT'],
            },
            tariffChart: {
                title: `Evolution du montant moyen de fourniture du kWh  (en c€ HT/kWh)`,
                precision: null,
                series: [
                    {
                        name: `Tarifs Bleus`,
                    },
                    {
                        name: `Tarifs Jaunes`,
                    },
                    {
                        name: `Tarifs Verts`,
                    },
                ],
                yaxisTitleLeft: `Montant moyen (c€ HT/kWh)`,
                xaxisTitle: `Exercices`,
                unitTooltip: 'c€ HT/kWh',
            },
        },
    },
    edfQuality: {
        path: 'edf-customers/quality',
        sidebarLabel: 'Qualité EDF',
        title: 'Gestion clientèle - EDF',
        subTitle: "Indicateurs de qualité de service d'EDF",
        texts: {
            successPhoneCallRate: {
                title: `Taux de réussite aux appels téléphoniques par EDF (en %) - maille nationale`,
                description: {
                    title: `Precision`,
                    content: `
                        <p>
                            Le taux de réussite aux appels téléphoniques présenté par EDF correspond au ratio entre le nombre d'appels reçus de la part des clients qui ont pu joindre un conseiller d'EDF, par rapport au nombre total d'appels reçus par EDF.
                        </p>
                        <p class="mb-0">
                            Ce taux est calculé et présenté par EDF à une maille unique, la maille nationale.
                        </p>
                    `,
                },
                precision: 1,
                suffix: ' %',
                badge: {
                    suffix: ' points',
                    precision: 1,
                },
            },
            monthlySubscriptionRate: {
                title: `Taux de contrats au Tarif Bleu Résidentiel qui sont mensualisés `,
                description: {
                    title: `Precision`,
                    content: `
                        <div>
                            La mensualisation permet au client de payer tous les mois un montant identique établi sur la base d’une estimation annuelle de ses consommations.
                        </div>
                        <div>
                            Ainsi, la charge financière est lissée sur l’ensemble des mois de l’année, la facturation donnant lieu à versement d’acomptes (en général 11) dont la somme est prédéterminée lors de la constitution de l’échéancier.
                        </div>
                        <div>
                            Une fois la dernière échéance réglée, EDF facture au client la différence entre les kWh réellement consommés dans l’année (index relevé) et ce qu’il a déjà payé. Cette facture de régularisation peut donc soit :
                            <ul>
                                <li>
                                    être d'un montant plus élevé que les mensualités, si le client a consommé plus que ce qui lui a été facturé jusqu'à présent,
                                </li>
                                <li>
                                    mentionner une somme négative si le client a consommé moins que prévu : le solde est alors créditeur et EDF rembourse au client le trop-perçu par virement bancaire sous 15 jours.
                                </li>
                            </ul>
                        </div>
                        <div>
                            Le taux de clients Tarif Bleu Résidentiels (TB R) mensualisés représente le ratio entre le nombre de clients mensualisés, par rapport au nombre total de clients TB R de la concession.
                        </div>
                    `,
                },
                precision: 1,
                suffix: ' %',
                badge: {
                    suffix: ' points',
                    precision: 1,
                },
            },
            phoneCallSuccessRateChart: {
                title: "Taux de réussite aux appels téléphoniques et délai moyen d'attente téléphonique (en minutes et secondes) - Maille nationale",
                series: [
                    {
                        name: 'Taux de réussite aux appels téléphoniques',
                        precision: null,
                    },
                    {
                        name: "Délai moyen d'attente",
                        precision: null,
                    },
                ],
                yaxisTitleLeft: `Taux de réussite (%)`,
                yaxisTitleRight: `Délai moyen d'attente (min. et sec.)`,
                xaxisTitle: `Exercices`,
            },
            edfCtsClientRateChart: {
                title: "Taux de clients ayant bénéficié d'un Conseil Tarifaire Simplifié (CTS) dans l'année",
                ctsClientRateTitle: "Taux de clients ayant bénéficié d'un CTS",
                precision: null,
                yaxisTitleLeft: `Taux de clients (%)`,
                xaxisTitle: `Exercices`,
                unitTooltip: '%',
            },
            edfSelfReportBillsRateChart: {
                title: 'Taux de factures basées sur un auto-relevé',
                selfReportBillsRateTitle: 'Taux de factures basées sur un auto-relevé',
                precision: null,
                yaxisTitleLeft: `Taux de factures (%)`,
                xaxisTitle: `Exercices`,
                unitTooltip: '%',
            },
            edfBlueContractRateChart: {
                title: 'Evolution des taux de contrats au tarif Bleu Résidentiel mensualisés et prélevés automatiquement',
                automaticPaymentTitle: 'Taux de contrats prélevés automatiquement',
                monthlyPaymentTitle: 'Taux de contrats mensualisés',
                precision: null,
                yaxisTitleLeft: `Taux de contrats (%)`,
                xaxisTitle: `Exercices`,
                unitTooltip: '%',
            },
            edfBlueContractRateComparisonChart: {
                title: 'Comparaison des taux de contrats au tarif Bleu Résidentiel mensualisés et prélevés automatiquement',
                serieLabel: 'Statistiques AEC',
                aecMeanLabel: 'Moyenne AEC',
                clientValueLabel: 'Valeur de la concession',
                serieLabelAvg: 'Moyenne AEC',
                serieLabelValue: 'Valeur de la concession',
                precision: null,
            },
        },
    },
    edfClaims: {
        path: 'edf-customers/claims',
        sidebarLabel: 'Réclamations EDF',
        title: 'Gestion clientèle - EDF',
        subTitle: 'Réclamations traitées par EDF',
        texts: {
            claimCount: {
                title: `Nombre total de réclamations traitées par EDF (uniquement écrites et uniquement pour les clients Tarif Bleu Résidentiels)`,
                description: {
                    title: `Precision`,
                    content: `
                        <div>
                            Dans le volume total de réclamations répondues par EDF, le fournisseur n'intégre pas toutes les réclamations.
                            <ul>
                                <li>
                                    Les réclamations des clients au Tarifs Bleu Résidentiels (TB R) sont incluses;
                                </li>
                                <li>
                                    Les réclamations des canaux "écrits" sont incluses (courrier, mail et Internet).
                                </li>
                            </ul>
                        </div>
                        <p>
                            Le fournisseur comptabilise les réclamations en Instance d'appels, mais dans un autre indicateur.
                        </p>
                        <div>
                            En revanche, EDF exclu de cet indicateur les réclamations :
                            <ul class="mb-0">
                                <li>
                                    des clients au Tarifs Bleu Non Résidentiels (TB NR);
                                </li>
                                <li>
                                    des clients faites à l'oral (réclamations par téléphone).
                                </li>
                            </ul>
                        </div>
                    `,
                },
                precision: 0,
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
            },
            treatedClaimRate: {
                title: `Taux de réponse par le fournisseur aux réclamations sous 30 jours calendaires (en %)`,
                precision: 1,
                suffix: ' %',
                badge: {
                    suffix: ' points',
                    precision: 1,
                },
            },
            evolcomplaintsEdfChart: {
                title: `Evolution de la répartition des réclamations ECRITES traitées par EDF (uniquement clients aux tarifs Bleu Résidentiel), par item`,
                qualitySupplyAxisTitle: 'Qualité de fourniture',
                contractAxisTitle: 'Contrat',
                receptionAxisTitle: 'Accueil',
                adviceServiceAxisTitle: 'Conseil/Service',
                recoveryAxisTitle: 'Recouvrement',
                reportAxisTitle: 'Relève',
                bilingAxisTitle: 'Facturation',
                relationDistributorAxisTitle: 'Relations avec le distributeur',
                totalTitle: 'Total',
                precision: null,
                yaxisTitleLeft: `Nombre de réclamations ECRITES`,
                xaxisTitle: `Exercices`,
            },
            distribComplaintsEdfChart: {
                title: `Répartition des réclamations reçues et traités par EDF, par canal de réception (en %)`,
                internetMailAxisTitle: 'Internet & mail',
                lettersAxisTitle: 'Courrier',
                precision: null,
                yaxisTitleLeft: `Répartition des canaux de réception (%)`,
                xaxisTitle: `Exercices`,
                unitTooltip: '%',
            },
            evolRateComplaintsEdfChart: {
                title: `Evolution du taux de réponse aux réclamations par EDF sous 30 jours calendaires`,
                rateComplaintsAxisTitle: 'Taux de réponse aux réclamations par EDF sous 30 jours',
                precision: null,
                yaxisTitleLeft: `Taux de réponse aux réclamations (%)`,
                xaxisTitle: `Exercices`,
            },
            edfClaimRateComparisonChart: {
                title: "Comparaison du taux de réclamations traitées par EDF pour 10 000 clients au TB de la concession avec les statistiques d'AEC",
                descriptionTitle: 'Précision',
                descriptionContent: `Les indicateurs sont disponibles dans les CRAC.
Les statistiques d'AEC pour ces ratios ont été calculées sur un panel de plus de 90 concessions, avec un minimum de 60 000 usagers.`,
                serieLabel: 'Statistiques AEC',
                aecMeanLabel: 'Moyenne AEC',
                clientValueLabel: 'Valeur de la concession',
                serieLabelAvg: 'Moyenne AEC',
                serieLabelValue: 'Valeur de la concession',
                precision: null,
            },
            edfClaimRateMap: {
                title: `Carte du taux de réclamations traitées par EDF pour 10 000 usagers, par commune`,
                descriptionTitle: 'Précision',
                descriptionContent: `Les communes déléguées au sein de communes nouvelles ne sont pas distinguées sur les cartes, les indicateurs sont cumulés à la maille de la commune nouvelle.`,
            },
        },
    },
    energyPoverty: {
        path: 'edf-customers/energy-poverty',
        sidebarLabel: 'Précarité Énergétique',
        title: 'Gestion clientèle - EDF',
        subTitle: 'Précarité énergétique',
        texts: {
            beneficiariesNumber: {
                title: `Nombre de bénéficiaires du chèque énergie, chez EDF, à fin d'année`,
                precision: 0,
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
                description: {
                    title: `Precision`,
                    content: `Le Chèque Energie remplace depuis le 1er janvier 2018 le Tarif de Première Nécessité (TPN), il est envoyé aux ayants-droits sous conditions de
                    ressources.<br>
                    Le volume indiqué concerne uniquement les Chèques Energie reçus par le fournisseur EDF pour les clients aux TRV.<br>
                    Les clients de fournisseurs alternatifs et les clients en offre de marchés chez EDF peuvent également transmettre leurs Chèques Energie, mais ces volumes ne sont pas connus (hors périmètre de la concession).`,
                },
            },
            reductionsPowerNumber: {
                title: `Nombre de réductions de puissance pour impayés enregistrées par le fournisseur en cours d'année`,
                precision: 0,
                badge: {
                    suffix: ' %',
                    precision: 1,
                },
                description: {
                    title: `Precision`,
                    content: `Depuis 2022, le fournisseur aux TRV (EDF) a fait le choix de ne plus demander de coupure effective pour les situations d'impayés.<br>
                Désormais, ce sont des réductions de puissance qui sont demandées en cas d'impayés. Elles sont notamment télé-opérées à distance pour les PDL avec des compteurs Linky.`,
                },
            },
            evolNbrBeneficiariesChart: {
                title: `Evolution du nombre de bénéficiaires du TPN puis chèque énergie à fin d'année`,
                nbrTpnBeneficiariesAxisTitle: 'Nombre de bénéficiaires du TPN',
                nbrCheckEnergyAxisTitle: 'Nombre de bénéficiaires du Chèque Energie',
                nbrCertificatesAxisTitle: `Nombre d'attestation reçues par EDF`,
                rateTpnAxisTitle: 'Taux de bénéficiaires du TPN',
                rateCheckEnergyAxisTitle: 'Taux de bénéficiaires du Chèque Energie',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Nombre de bénéficiaires à fin d'année`,
                yaxisTitleRight: `Taux`,
                xaxisTitle: `Exercices`,
            },
            evolAmountFileAssistedChart: {
                title: `Evolution du montant alloué par EDF au FSL (en k€) et du nombre de dossiers aidés`,
                amountAllocatedEdfAxisTitle: 'Montant alloué par EDF au FSL du département (en k€)',
                nbrCustomersEdfAxisTitle: `Nombre de clients d'EDF ayant bénéficié d'une aide FSL`,
                precision: null,
                yaxisTitleLeft: `Montant alloué (k€)`,
                yaxisTitleRight: `Nombre de dossiers FSL`,
                xaxisTitle: `Exercices`,
            },
            evolReducPowerChart: {
                title: `Evolution des réductions de puissance effectives enregistrées par le fournisseur`,
                nbrPowerReductAxisTitle: 'Nombre de réductions de puissance effectives',
                nbrPowerWinterReductAxisTitle:
                    'Dont nombre de réductions de puissance hivernales effectives',
                ratioPowerReductAxisTitle:
                    'Ratio de réductions de puissance effectives, pour 10 000 clients aux TRV',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Nombre de réductions de puissance`,
                yaxisTitleRight: `Ratio de réductions de puissance (‱)`,
                xaxisTitle: `Exercices`,
            },
            evolCutsSupplierChart: {
                title: `Evolution des coupures effectives pour impayés à la demande du fournisseur`,
                nbrCutsUnpaidAxisTitle: 'Nombre de coupures pour impayés effectives',
                ratioCutsUnpaidAxisTitle:
                    'Ratio de coupures pour impayés, pour 10 000 clients aux TRV',
                precision: null,
                ratePrecision: null,
                yaxisTitleLeft: `Nombre de coupures pour impayés`,
                yaxisTitleRight: `Ratio de coupures pour impayés (‱)`,
                xaxisTitle: `Exercices`,
            },
        },
    },
    /*
    exportReport: {
        path: 'export_report',
        sidebarLabel: 'Export rapport',
        title: 'Export du rapport',
        subTitle: '',
        texts: {},
    },
    */
};

export enum StrokeLineCap {
    BUTT = 'butt',
    SQUARE = 'square',
    ROUND = 'round',
}
